 import React, { useContext, useEffect, useState, useMemo } from "react";
import { Search, Menu, User, X, ChevronLeft, ChevronRight, Calendar, Compass, Home, MessageCircle, Minus, Plus, Star, MapPin, Bell, ChevronDown, ChevronUp } from "lucide-react";
import { Tune } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../redux/store";
import { TextField } from "@mui/material";
import { FilledHeartIcon, OutlinedHeartIcon } from "../../../assets/svg/svg";
import pioneerBadgeImg from "../../../assets/badges/pioneer.png";
import {
  amenitiesCategories,
  propertyCategories,
} from "../../../CATEGORIES/Categories";


import { useDispatch, useSelector } from "react-redux";
 import { fetchAllShortRatingSummaries } from "../../../redux/shortRatingSlice";
import {
  addToWishlist,
  fetchWishlist,
  removeFromWishlist,
} from "../../../redux/wishlistSlice";
import { listenToPublishedShortstays,listenToAvailableLocations, setFilters, clearFilters, ShortstayListing } from "../../../redux/shortstaysSlice";

import dayjs from "dayjs";
import { AppDispatch } from "../../../redux/store";
import { listenToAllShortstayReservations } from "../../../redux/shortstayReservationSlice";
import { calculateFinalPricesForAllListings } from "../../../redux/shortstayServiceFeeSlice";
import { listenToUserNotifications, stopUserNotificationsListener, } from "../../../redux/notificationsSlice";
import { useCurrency } from "@cosmoola/react-cosmoola-js";
import logoImg from "../../../assets/app/logo.png";
import { logout, fetchAllUsers  } from "../../../redux/authSlice";
import SmartFooter from "../../../../COMMANDS/SUPERAPP/SmartFooter";





/* ======================================================
   CONSTANTS
====================================================== */
const GOLD_GRADIENT = "linear-gradient(135deg,#C8202E,#C8202E)";
const GREY_BG = "#ebebeb";
const LUXURY_GRADIENT = "linear-gradient(135deg, #C8202E 0%, #cfcfcf 45%, #111 100%)";
const BLACK_GOLD_GRADIENT = "linear-gradient(135deg, #111 0%, #C8202E 100%)";
const H_PADDING = 24; // shared horizontal padding for header, categories, and grid



const BLACK_CORAL_GRADIENT = "linear-gradient(135deg, #1B0E06 0%, #C8202E 100%)";



/* ======================================================
   TYPES
====================================================== */
type ActiveSection =
  | "where"
  | "dates"
  | "who"
  | "filters"
  | "menu"
  | "mobile"
  | null;


  type CardKey = "where" | "when" | "who" | "search" | null;

  const MOBILE_VISIBLE_COUNT = 2;

// Minimal country → continent map. Extend as needed.
const COUNTRY_TO_CONTINENT: Record<string, string> = {
  estonia: "Europe", latvia: "Europe", lithuania: "Europe", finland: "Europe",
  sweden: "Europe", norway: "Europe", denmark: "Europe", germany: "Europe",
  france: "Europe", spain: "Europe", italy: "Europe", portugal: "Europe",
  poland: "Europe", "united kingdom": "Europe", ireland: "Europe",
  netherlands: "Europe", belgium: "Europe", austria: "Europe",
  switzerland: "Europe", greece: "Europe", "czech republic": "Europe",
  hungary: "Europe", romania: "Europe", croatia: "Europe", iceland: "Europe",

  "united states": "North America", canada: "North America", mexico: "North America",

  brazil: "South America", argentina: "South America", chile: "South America",
  peru: "South America", colombia: "South America",

  nigeria: "Africa", kenya: "Africa", "south africa": "Africa", egypt: "Africa",
  morocco: "Africa", ghana: "Africa", tanzania: "Africa", ethiopia: "Africa",

  china: "Asia", japan: "Asia", india: "Asia", thailand: "Asia",
  "united arab emirates": "Asia", "south korea": "Asia", indonesia: "Asia",
  vietnam: "Asia", "saudi arabia": "Asia", israel: "Asia", turkey: "Asia",

  australia: "Oceania", "new zealand": "Oceania", fiji: "Oceania",
};

const getContinent = (country?: string | null): string | null => {
  if (!country) return null;
  return COUNTRY_TO_CONTINENT[country.toLowerCase().trim()] ?? null;
};

// Platform launch date — start of the "early hosts" eligibility window.
const PLATFORM_LAUNCH_DATE = new Date("2026-01-01T00:00:00Z").getTime();
const EARLY_HOST_WINDOW_MS = 2 * 365 * 24 * 60 * 60 * 1000; // 2 years
const EARLY_HOST_CUTOFF = PLATFORM_LAUNCH_DATE + EARLY_HOST_WINDOW_MS;

/* ======================================================
   COMPONENT
====================================================== */
const VacationRentals: React.FC<{ embedded?: boolean }> = ({ embedded = false }) => {
const dispatch = useDispatch<AppDispatch>();
//const { rate, symbol, currency } = useContext(CurrencyContext);
// REPLACE WITH:
const { convertRaw, symbol, setCurrency } = useCurrency();

useEffect(() => {
  setCurrency("EUR");
}, []);


const filters = useSelector((state: RootState) => state.shortstays.filters);
const listings = useSelector((state: RootState) => state.shortstays.listings);

const allReservations = useSelector((state: RootState) => state.shortstayReservations.allReservations);
const blockedListingIds = useSelector((state: RootState) => state.shortstayReservations.blockedListingIds);

  const [active, setActive] = useState<ActiveSection>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const [hideTabBar, setHideTabBar] = useState(false);
const lastScrollY = React.useRef(0);

const headerRef = React.useRef<HTMLDivElement | null>(null);
const [headerHeight, setHeaderHeight] = useState(76);



  const [amenitiesFilter, setAmenitiesFilter] = useState<number[]>([]);
const [cancellationFilter, setCancellationFilter] = useState<"any" | "free" | "partial" | "system">("any");
const [rateTypeFilter, setRateTypeFilter] = useState<"any" | "perNight" | "perNightPerPerson" | "perHour" | "perHourPerPerson" | "perWeek" | "perMonth" | "perYear">("any");

const SHOW_AMENITY_IMAGES = false;
const managers = useSelector((state: RootState) => state.auth.managers as string[] | undefined);
const maxListingPrice = useMemo(() => {
  if (!listings.length) return 1000;
 // return Math.max(...listings.map((l) => (l.rate ?? 0) * rate));
return Math.max(...listings.map((l) => convertRaw(l.rate ?? 0, "EUR")));
}, [listings, convertRaw]);

const [priceRange, setPriceRange] = useState({
  min: 0,
  max: maxListingPrice,
});

const [taxOn, setTaxOn] = useState<boolean>(() => {
  const saved = localStorage.getItem("shortstay:showTotalPrice");
  return saved === null ? true : saved === "true";
});
const navigate = useNavigate();
const user = useSelector((state: RootState) => state.auth.user);
const isAuthenticated = Boolean(user?.userId);

const allUsers = useSelector((state: RootState) => state.auth.allUsers);

useEffect(() => {
  if (!allUsers || allUsers.length === 0) {
    dispatch(fetchAllUsers());
  }
}, [dispatch, allUsers.length]);

const hostJoinDateMap = useMemo(() => {
  const map: Record<string, number> = {};
  allUsers.forEach((u) => {
    if (u.userId && u.joinDate) {
      const ts = new Date(u.joinDate).getTime();
      if (!isNaN(ts)) map[u.userId] = ts;
    }
  });
  return map;
}, [allUsers]);


const wishlist = useSelector(
  (state: RootState) => state.wishlist.shortstays
);

const availableLocations = useSelector(
  (state: RootState) => state.shortstays.locations
);


/*======================logic use states===================================*/
const [whenMode, setWhenMode] = useState<"dates" | "months" | "flex" | "years">("dates");
const [checkIn, setCheckIn] = useState<Date | null>(null);
const [checkOut, setCheckOut] = useState<Date | null>(null);
const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
const [flexLength, setFlexLength] = useState<"Weekend" | "Week" | "Month" | null>(null);
const [flexMonth, setFlexMonth] = useState<string | null>(null);
const [years, setYears] = useState<number>(1);
const updateYears = (delta: number) =>
  setYears((y) => Math.max(1, y + delta));
const [monthOffset, setMonthOffset] = useState(0);


const [guests, setGuests] = useState({
  adults: 0,
  children: 0,
  infants: 0,
  pets: 0,
});

const updateGuest = (key: keyof typeof guests, delta: number) => {
  setGuests((prev) => ({
    ...prev,
    [key]: Math.max(0, prev[key] + delta),
  }));
};
const [showPioneerSection, setShowPioneerSection] = useState(true);

useEffect(() => {
  if (!showPioneerSection) return; // don't re-arm once manually/auto closed... unless reopened
  const timer = setTimeout(() => setShowPioneerSection(false), 2 * 60 * 1000); // 2 minutes
  return () => clearTimeout(timer);
}, [showPioneerSection]);

const [openCard, setOpenCard] = useState<CardKey>(null);

// Passive device location — independent of search filters, never cleared by "Clear"
const [deviceLocation, setDeviceLocation] = useState<{
  city: string | null;
  country: string | null;
  continent: string | null;
  lat: number | null;
  lng: number | null;
} | null>(null);


const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
const categoriesScrollRef = React.useRef<HTMLDivElement | null>(null);

const inputRef = React.useRef<HTMLInputElement | null>(null);
const [locationText, setLocationText] = useState("");
const [suggestions, setSuggestions] = useState<any[]>([]);

const totalGuests =
  guests.adults + guests.children + guests.infants + guests.pets;

const guestsPreview =
  totalGuests > 0 ? `${totalGuests} guest${totalGuests > 1 ? "s" : ""}` : "Add guests";


const locationPreview =
  locationText ||
  [filters.address?.city, filters.address?.country]
    .filter(Boolean)
    .join(", ") ||
  "Search destinations";


  const notifications = useSelector(
  (s: RootState) => s.notifications.notifications
);

const unreadCount = useMemo(
  () => notifications.filter(n => !n.read).length,
  [notifications]
);






const scrollTimer = React.useRef<ReturnType<typeof setTimeout> | null>(null);

useEffect(() => {
  const handleScroll = () => {
    const currentY = window.scrollY;
    setHideTabBar(currentY > lastScrollY.current && currentY > 60);
    lastScrollY.current = currentY;

    // clear any existing timer
    if (scrollTimer.current) clearTimeout(scrollTimer.current);

    // after 300ms of no scrolling → show tabs again
    scrollTimer.current = setTimeout(() => {
      setHideTabBar(false);
    }, 300);
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
  return () => {
    window.removeEventListener("scroll", handleScroll);
    if (scrollTimer.current) clearTimeout(scrollTimer.current);
  };
}, []);


useEffect(() => {
  if (active === "mobile" || active === "menu") {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
}, [active]);


  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (!headerRef.current) return;
    const el = headerRef.current;
    const updateHeight = () => setHeaderHeight(el.offsetHeight);
    updateHeight();
    const ro = new ResizeObserver(updateHeight);
    ro.observe(el);
    return () => ro.disconnect();
  }, [isMobile]);

  const isDimmed = (key: ActiveSection) =>
    active !== null && active !== key;

  const toggle = (key: ActiveSection) =>
    setActive((prev) => (prev === key ? null : key));



  useEffect(() => {
  
    const unsub = listenToPublishedShortstays()(dispatch);
  
    return () => {
      if (typeof unsub === "function") unsub();
    };
  }, [dispatch]);


  
  useEffect(() => {
  dispatch(listenToAvailableLocations());
}, [dispatch]);



useEffect(() => {
  let unsub: any;

  if (checkIn && checkOut) {
    const formattedCheckIn = dayjs(checkIn).format("YYYY-MM-DD");
    const formattedCheckOut = dayjs(checkOut).format("YYYY-MM-DD");

    unsub = dispatch(
      listenToAllShortstayReservations(
        formattedCheckIn,
        formattedCheckOut
      )
    );
  } else {
    // 🔥 No dates → listen without overlap logic
    unsub = dispatch(listenToAllShortstayReservations());
  }

  return () => {
    if (typeof unsub === "function") unsub();
  };
}, [checkIn, checkOut, dispatch]);


// REPLACE the suggestions useEffect
useEffect(() => {
  if (!locationText.trim()) {
    setSuggestions([]);
    return;
  }

  const search = locationText.toLowerCase();

  const seen = new Set<string>();
  const filtered = availableLocations.filter((loc: any) => {
    const matches =
      loc.city?.toLowerCase().includes(search) ||
      loc.country?.toLowerCase().includes(search) ||
      loc.neighborhood?.toLowerCase().includes(search);

    if (!matches) return false;
    const key = `${loc.city || ""}-${loc.country || ""}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });

  setSuggestions(filtered.slice(0, 6));
}, [locationText, availableLocations]);



  useEffect(() => {
  if (!window.google || !inputRef.current) return;

  const autocomplete = new window.google.maps.places.Autocomplete(
    inputRef.current,
    { types: ["(cities)"] }
  );

  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();

 const city =
  place.address_components?.find(
    (c: google.maps.GeocoderAddressComponent) =>
      c.types.includes("locality")
  )?.long_name || null;

const country =
  place.address_components?.find(
    (c: google.maps.GeocoderAddressComponent) =>
      c.types.includes("country")
  )?.long_name || null;


    setLocationText(place.name || "");

// REPLACE WITH THIS
const lat = place.geometry?.location?.lat() ?? null;
const lng = place.geometry?.location?.lng() ?? null;

const viewport = place.geometry?.viewport;
const bounds = viewport ? {
  neLat: viewport.getNorthEast().lat(),
  neLng: viewport.getNorthEast().lng(),
  swLat: viewport.getSouthWest().lat(),
  swLng: viewport.getSouthWest().lng(),
} : null;

dispatch(
  setFilters({
    address: {
      city,
      country,
      neighborhood: null,
      latitude: lat,
      longitude: lng,
      bounds,
    },
  })
);
setOpenCard("when");
setActive("dates");

  });
}, [dispatch]);

  
// Passive geolocation → local fallback state ONLY (never touches Redux filters,
// so "Clear" / "View all" never wipes it out)
useEffect(() => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((pos) => {
      const lat = pos.coords.latitude;
      const lng = pos.coords.longitude;

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        { location: { lat, lng } },
        (
          results: google.maps.GeocoderResult[] | null,
          status: google.maps.GeocoderStatus
        ) => {
          if (status === "OK" && results?.[0]) {
            const city =
              results[0].address_components.find(
                (c: google.maps.GeocoderAddressComponent) =>
                  c.types.includes("locality")
              )?.long_name || null;

            const country =
              results[0].address_components.find(
                (c: google.maps.GeocoderAddressComponent) =>
                  c.types.includes("country")
              )?.long_name || null;

            setDeviceLocation({
              city,
              country,
              continent: getContinent(country),
              lat,
              lng,
            });
          }
        }
      );
    });
  }
}, []);



useEffect(() => {
  if (user?.userId) {
    dispatch(fetchWishlist({ userId: user.userId, type: "shortstays" }));
  }
}, [dispatch, user?.userId]);





useEffect(() => {
  // 🔕 toggle OFF → clear totals
  if (!taxOn) {
    dispatch({
      type: "shortstayServiceFees/clearFinalPrices",
    });
    return;
  }
  if (!checkIn || !checkOut) return;
  const start = dayjs(checkIn);
  const end = dayjs(checkOut);
  const nights = end.diff(start, "day");
  if (nights <= 0) return;
  const totalGuests =
    guests.adults +
    guests.children +
    guests.infants +
    guests.pets;
  dispatch(
    calculateFinalPricesForAllListings({
      reservedDuration: nights,
      adults: Math.max(1, totalGuests), // safety
    })
  );
}, [
  taxOn,
  checkIn,
  checkOut,
  guests.adults,
  guests.children,
  guests.infants,
  guests.pets,
  dispatch,
]);

useEffect(() => {
  localStorage.setItem("shortstay:showTotalPrice", String(taxOn));
}, [taxOn]);


useEffect(() => {
  if (!user?.userId) return;

  dispatch(listenToUserNotifications(user?.userId));

  return () => {
    dispatch(stopUserNotificationsListener());
  };
}, [dispatch, user?.userId]);


const handleLogout = async () => {
  try {
    await dispatch(logout()).unwrap();
    navigate("/");
  } catch (error) {
    console.error("Logout failed:", error);
  }
};

//logic
const handleTabClick = (path: string | ((userId: string) => string)) => {
  if (!isAuthenticated || !user?.userId) {
    navigate("/AuthSwitch");
    return;
  }

  const finalPath =
    typeof path === "function" ? path(user.userId) : path;

  navigate(finalPath);
};


useEffect(() => {
  if (whenMode !== "years") return;

  const start = dayjs();
  const end = start.add(years, "year");

  setCheckIn(start.toDate());
  setCheckOut(end.toDate());
}, [years, whenMode]);

const MobileExpandableCard = ({
  id,
  title,
  preview,
  openCard,
  setOpenCard,
  children,
}: any) => {
  const open = openCard === id;

  return (
    <div style={styles.mobileCard}>
      {!open ? (
        <div onClick={() => setOpenCard(id)} style={styles.cardPreview}>
          <span>{title}</span>
          <strong>{preview}</strong>
        </div>
      ) : (
        <>
          <h3 style={{ padding: "16px 16px 0" }}>{title}</h3>
          <div style={{ padding: 16 }}>{children}</div>
        </>
      )}
    </div>
  );
};

type MobileCalendarProps = {
  checkIn: Date | null;
  checkOut: Date | null;
  setCheckIn: (d: Date | null) => void;
  setCheckOut: (d: Date | null) => void;
};

const MobileCalendar: React.FC<MobileCalendarProps> = ({
  checkIn,
  checkOut,
  setCheckIn,
  setCheckOut,
}) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const sameDay = (a: Date, b: Date) =>
    a.toDateString() === b.toDateString();

  const inRange = (d: Date) =>
    checkIn && checkOut && d > checkIn && d < checkOut;

  const handleSelect = (date: Date) => {
    if (!checkIn || (checkIn && checkOut)) {
      setCheckIn(date);
      setCheckOut(null);
      return;
    }

    if (date < checkIn) {
      setCheckIn(date);
      return;
    }

    setCheckOut(date);
  };

  const renderMonth = (offset: number) => {
    const base = new Date();
    base.setMonth(base.getMonth() + offset);

    const year = base.getFullYear();
    const month = base.getMonth();

    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();

    const days: (Date | null)[] = [
      ...Array(firstDay).fill(null),
      ...Array.from({ length: daysInMonth }, (_, i) => new Date(year, month, i + 1)),
    ];

    return (
      <div style={{ marginBottom: 28 }}>
<div
  style={{
    fontWeight: 700,
    fontSize: 16,
    marginBottom: 12,
    textAlign: "center",
  }}
>
          {base.toLocaleString(undefined, { month: "long", year: "numeric" })}
        </div>

        {/* WEEKDAYS */}
        <div style={styles.weekRow}>
          {["S", "M", "T", "W", "T", "F", "S"].map((d) => (
            <div key={d} style={styles.weekLabel}>{d}</div>
          ))}
        </div>

        {/* DAYS */}
        <div style={styles.daysGrid}>
          {days.map((day, i) => {
            if (!day) return <div key={i} />;

            const disabled = day < today;
            const start = checkIn && sameDay(day, checkIn);
            const end = checkOut && sameDay(day, checkOut);

            return (
              <div
  key={i}
  style={{
    position: "relative",
    display: "flex",
    justifyContent: "center",
  }}
>
  {inRange(day) && <div style={styles.rangeBg} />}

                <button
                  disabled={disabled}
                  onClick={() => handleSelect(day)}
                  style={{
                    ...styles.dayBtn,
                  background: start || end ? GOLD_GRADIENT : "transparent",
                  boxShadow:
                  start || end ? "0 2px 6px rgba(0,0,0,.25)" : "none",

                    color:
                      disabled
                        ? "#ccc"
                        : start || end
                        ? "#121212"
                        : "#333",
                    cursor: disabled ? "not-allowed" : "pointer",
                  }}
                >
                  {day.getDate()}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
  <div style={{ maxHeight: 500, overflowY: "auto" }}>
    {Array.from({ length: 60 }, (_, i) => renderMonth(i))}
  </div>
  );
};




const scrollCategories = (direction: "left" | "right") => {
  if (!categoriesScrollRef.current) return;

  const scrollAmount = 240; // tweak feel here
  categoriesScrollRef.current.scrollBy({
    left: direction === "left" ? -scrollAmount : scrollAmount,
    behavior: "smooth",
  });
};





const generateUnavailableDates = (stay: typeof listings[0]) => {
  const dates = new Set<string>();

  // Add reserved dates
  const reserved = allReservations.filter((r) => r.listingId === stay.listingId);
  reserved.forEach((r) => {
    const start = dayjs(r.checkIn);
    const end = dayjs(r.checkOut);
    for (let d = start; d.isBefore(end); d = d.add(1, "day")) {
      dates.add(d.format("YYYY-MM-DD"));
    }
  });

  // Add unavailableDates (stored in shortstays listing)
  if (stay.unavailableDates && Array.isArray(stay.unavailableDates)) {
    stay.unavailableDates.forEach((d: string) => {
      dates.add(dayjs(d).format("YYYY-MM-DD"));
    });
  }

  return dates;
};


const applySearchFilters = () => {
  const payload: any = {};
  if (filters.address) {
    payload.address = filters.address;
  }
  if (checkIn && checkOut) {
    const start = dayjs(checkIn);
    const end = dayjs(checkOut);
    const nights = end.diff(start, "day");

    if (nights > 0) {
      payload.checkIn = start.format("YYYY-MM-DD");
      payload.checkOut = end.format("YYYY-MM-DD");
      payload.minNights = nights;
      payload.maxNights = nights;
    }
  }
  if (totalGuests > 0) {
    payload.guests = totalGuests;
  }
    if (selectedCategoryId) {
    payload.category = selectedCategoryId;
  }

  dispatch(setFilters(payload));
  setActive(null);
  setOpenCard(null);
    setAmenitiesFilter([]);
  setPriceRange({ min: 0, max: maxListingPrice });
};

const clearAllFilters = () => {
  // 🔁 Redux filters
dispatch(clearFilters());

  // 📍 Location
  setLocationText("");
  setSuggestions([]);

  // 📅 Dates
  setCheckIn(null);
  setCheckOut(null);
  setSelectedMonth(null);
  setFlexLength(null);
  setFlexMonth(null);
  setYears(1);
  setWhenMode("dates");
 setCancellationFilter("any");
 setRateTypeFilter("any");
  // 👥 Guests
  setGuests({
    adults: 0,
    children: 0,
    infants: 0,
    pets: 0,
  });

  // 🏷 Categories
  setSelectedCategoryId(null);

  // 🧭 UI state
  setOpenCard(null);
    setAmenitiesFilter([]);
  setPriceRange({ min: 0, max: maxListingPrice });
};









const filteredListings = useMemo(() => {
  if (!filters) return listings;

  // Normalize to midnight UTC — handles both "2026-05-10" and "2026-06-01T00:00:00Z"
  const toMidnightUTC = (dateStr: string) =>
    Date.parse(`${dateStr.split("T")[0]}T00:00:00Z`);

  const selectedStart = checkIn ? toMidnightUTC(dayjs(checkIn).format("YYYY-MM-DD")) : null;
  const selectedEnd   = checkOut ? toMidnightUTC(dayjs(checkOut).format("YYYY-MM-DD")) : null;

  const nights =
    checkIn && checkOut
      ? dayjs(checkOut).diff(dayjs(checkIn), "day")
      : 0;

  return listings.filter((stay) => {

const userManuallySearched = locationText.trim() !== "";
    const bounds = filters.address?.bounds;
    const userCountry = filters.address?.country;
    const userCity = filters.address?.city;
    const userNeighborhood = filters.address?.neighborhood;
    const stayLat = stay.address?.latitude;
    const stayLng = stay.address?.longitude;

    const locationMatch = (() => {
      // Nothing set at all → show everything
      if (!userManuallySearched && !userCountry) return true;

      // Manual search + Google Autocomplete gave viewport bounds
      if (userManuallySearched && bounds && stayLat && stayLng) {
        return (
          stayLat >= bounds.swLat &&
          stayLat <= bounds.neLat &&
          stayLng >= bounds.swLng &&
          stayLng <= bounds.neLng
        );
      }

      // Manual search, no bounds (Firestore suggestion) → text match
 // Manual search, no bounds (Firestore suggestion) → text match
      if (userManuallySearched) {
        return (
          (userCity
            ? stay.address?.city?.toLowerCase().includes(userCity.toLowerCase())
            : true) &&
          (userCountry
            ? stay.address?.country?.toLowerCase().includes(userCountry.toLowerCase())
            : true) &&
          (userNeighborhood
            ? (stay.address?.neighborhood?.toLowerCase().includes(userNeighborhood.toLowerCase()) ||
               (stay as any).neighborhood?.toLowerCase().includes(userNeighborhood.toLowerCase()))
            : true)
        );
      }

      // Auto geolocation only (passive) → country match
    // Auto geolocation only (passive) → country match
    if (deviceLocation?.country) {
        return stay.address?.country?.toLowerCase() === deviceLocation.country.toLowerCase();
      }

      return true;
    })();

    const guestMatch = filters.guests
      ? (stay.peopleAllowed ?? 1) >= filters.guests
      : true;

    const durationMatch =
      checkIn && checkOut
        ? nights >= (stay.minNights ?? 1) && nights <= (stay.maxNights ?? 365)
        : true;

    const categoryMatch = filters.category
      ? stay.category === filters.category
      : true;

    // ✅ CHECK 1: blockedListingIds from slice (covers both reservations + unavailableDates)
    const isBlockedBySlice =
      selectedStart && selectedEnd
        ? blockedListingIds.includes(stay.listingId)
        : false;

    // ✅ CHECK 2: double-check inline against allReservations (normalized)
    const isBlockedByReservation =
      selectedStart && selectedEnd
        ? allReservations.some((r) => {
            if (!r.isConfirmed || r.isCancelled || r.isRefunded) return false;
            if (r.listingId !== stay.listingId) return false;
            const existingStart = toMidnightUTC(r.checkIn);
            const existingEnd   = toMidnightUTC(r.checkOut);
            return selectedStart < existingEnd && selectedEnd > existingStart;
          })
        : false;

    // ✅ CHECK 3: check listing's own unavailableDates array directly
 // ✅ CHECK 3: check listing's own unavailableDates array directly
const isBlockedByUnavailable =
  selectedStart && selectedEnd && stay.unavailableDates?.length
    ? stay.unavailableDates.some((d: string) => {
        const blocked = toMidnightUTC(d);
        return selectedStart <= blocked && blocked < selectedEnd;
      })
    : false;

// ✅ CHECK 4: external platform blocks (Airbnb/VRBO/Booking.com) pulled in via daily sync
const isBlockedByExternalCalendar =
  selectedStart && selectedEnd && stay.externalBlockedDates?.length
    ? stay.externalBlockedDates.some((d: string) => {
        const blocked = toMidnightUTC(d);
        return selectedStart <= blocked && blocked < selectedEnd;
      })
    : false;

const isUnavailable =
  isBlockedBySlice || isBlockedByReservation || isBlockedByUnavailable || isBlockedByExternalCalendar;

  
    const convertedPrice = convertRaw(stay.rate ?? 0, "EUR");
    const priceMatch = convertedPrice >= priceRange.min && convertedPrice <= priceRange.max;

    const amenitiesMatch =
      amenitiesFilter.length > 0
        ? amenitiesFilter.every((id) => stay.amenities?.includes(id))
        : true;

    const cancellationMatch =
      cancellationFilter === "any" ? true
      : cancellationFilter === "free" ? stay.cancellationPolicy?.free === true
      : cancellationFilter === "partial" ? stay.cancellationPolicy?.partial === true
      : stay.cancellationPolicy?.system === true;

    const rateTypeMatch =
      rateTypeFilter === "any" ? true : stay.rateType === rateTypeFilter;

return locationMatch && guestMatch && durationMatch && categoryMatch &&
           priceMatch && amenitiesMatch && cancellationMatch && rateTypeMatch && !isUnavailable;
  });
}, [listings, filters, allReservations, blockedListingIds, priceRange, amenitiesFilter, convertRaw, checkIn, checkOut, cancellationFilter, rateTypeFilter, locationText, deviceLocation]);
// 🌍 Tiered fallback ordering: city → country → continent → rest of world.
// Only kicks in when the user hasn't manually typed/selected a search location —
// this is what powers "View all listings" showing relevant stuff first.
const sortedListings = useMemo(() => {
  const userManuallySearched = locationText.trim() !== "";
  const hasManualAddressFilter = Boolean(filters.address?.city || filters.address?.country);

  // If the user explicitly searched/selected somewhere, don't re-sort — respect their filter as-is.
  if (userManuallySearched || hasManualAddressFilter || !deviceLocation) {
    return filteredListings;
  }

  const tierOf = (stay: ShortstayListing extends never ? any : any) => {
    const stayCity = stay.address?.city?.toLowerCase().trim();
    const stayCountry = stay.address?.country?.toLowerCase().trim();
    const stayContinent = getContinent(stay.address?.country);

    const deviceCity = deviceLocation.city?.toLowerCase().trim();
    const deviceCountry = deviceLocation.country?.toLowerCase().trim();
    const deviceContinent = deviceLocation.continent;

    if (deviceCity && stayCity && stayCity === deviceCity) return 0; // same city
    if (deviceCountry && stayCountry && stayCountry === deviceCountry) return 1; // same country
    if (deviceContinent && stayContinent && stayContinent === deviceContinent) return 2; // same continent
    return 3; // rest of world
  };

  return [...filteredListings].sort((a, b) => tierOf(a) - tierOf(b));
}, [filteredListings, deviceLocation, locationText, filters.address]);




// The country the user is effectively browsing right now — manual search wins,
// otherwise fall back to passive device geolocation. This is what scopes the
// pioneer section, exactly like the main listings' locationMatch does.
const currentCountry = useMemo(() => {
  const manualCountry = locationText.trim() !== "" ? filters.address?.country : null;
  return (manualCountry ?? deviceLocation?.country ?? null)?.toLowerCase().trim() ?? null;
}, [locationText, filters.address?.country, deviceLocation]);

const topEarlyHostListings = useMemo(() => {
  if (!currentCountry) return [];

  const seenHosts = new Set<string>();
  const eligible: { stay: typeof listings[0]; hostJoinedAt: number }[] = [];

  // 🌍 Pull straight from the full `listings` pool (not the filtered/sorted grid) —
  // early hosts in the user's current country should ALWAYS show here, regardless
  // of guest count, dates, price, or amenity filters applied to the main grid.
  for (const stay of listings) {
    const stayCountry = stay.address?.country?.toLowerCase().trim();
    if (stayCountry !== currentCountry) continue;

    const hostId = stay.hostId;
    if (!hostId || seenHosts.has(hostId)) continue; // 1 listing per host

    const isSystemListing = Array.isArray(managers) && managers.includes(hostId);
    if (isSystemListing) continue;

    const ts = hostJoinDateMap[hostId];
    if (ts === undefined || isNaN(ts)) continue;
    if (ts < PLATFORM_LAUNCH_DATE || ts > EARLY_HOST_CUTOFF) continue;

    seenHosts.add(hostId);
    eligible.push({ stay, hostJoinedAt: ts });
  }

  // Earliest-joined host in this country appears first — "always at the top".
  eligible.sort((a, b) => a.hostJoinedAt - b.hostJoinedAt);

  return eligible.slice(0, 20).map((e) => e.stay);
}, [listings, currentCountry, hostJoinDateMap, managers]);


const filterAmenityIds = [
  1,  // Wi-Fi
  12, // generator
  13, // Gym / Fitness Center
  14, // Swimming Pool
  9,  // Washer
  10, // TV
  15, // elevator
  19, // breakfast
  31, // airport transfer
  29, // desk
  11, // kids
  3,  // Heating
  7,  // Air Conditioning
  21, // sauna
  23, // ev charge
];


const allowedAmenities = useMemo(() => {
  return amenitiesCategories.filter((a) =>
    filterAmenityIds.includes(a.id)
  );
}, []);


const whenPreview = useMemo(() => {
  if (checkIn && checkOut) {
    return {
      checkIn: dayjs(checkIn).format("MMM D YYYY"),
      checkOut: dayjs(checkOut).format("MMM D YYYY"),
      range: `${dayjs(checkIn).format("MMM D YYYY")} → ${dayjs(checkOut).format("MMM D YYYY")}`,
    };
  }

  return {
    checkIn: "Add dates",
    checkOut: "Add dates",
    range: "Any time",
  };
}, [checkIn, checkOut]);


const BATCH_SIZE = 6;
const [visibleCount, setVisibleCount] = useState(BATCH_SIZE);
const [initialLoad, setInitialLoad] = useState(true);

useEffect(() => {
  setVisibleCount(BATCH_SIZE);
}, [sortedListings]);

useEffect(() => {
  if (visibleCount >= sortedListings.length) return;
  const t = setTimeout(
    () => setVisibleCount((v) => Math.min(v + BATCH_SIZE, sortedListings.length)),
    500
  );
  return () => clearTimeout(t);
}, [visibleCount, sortedListings.length]);

useEffect(() => {
  const t = setTimeout(() => setInitialLoad(false), 700);
  return () => clearTimeout(t);
}, []);

const visibleListings = sortedListings.slice(0, visibleCount);
const isLoadingMore = visibleCount < sortedListings.length;

{/* ================= MAIN RETURN =========================================================================*/}
//**===================================================================================================== *//


  return (
<div style={embedded ? { position: "relative", width: "100%", overflowX: "hidden" } : styles.wrapper}>
  <div style={embedded ? { position: "relative", width: "100%", minWidth: 0 } : styles.pageContent}>
    {!embedded && <div style={styles.pageWatermark} />}
  <style>{`
    @keyframes aeSpin{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}
    @keyframes shimmer{0%{background-position:100% 0}100%{background-position:-100% 0}}
    @keyframes cardRiseIn{from{opacity:0;transform:translateY(18px) scale(.98);}to{opacity:1;transform:translateY(0) scale(1);}}
    @keyframes dotBounce{0%,80%,100%{transform:scale(0.6);opacity:.5}40%{transform:scale(1);opacity:1}}
  `}</style>      {/* ================= HEADER ================= */}

<section ref={headerRef} style={{
  ...styles.searchWrapper,
  position: embedded ? "sticky" : "fixed",
  top: 0,
  left: embedded ? "auto" : 0,
  right: embedded ? "auto" : 0,
  zIndex: embedded ? 10 : 200,
  width: "100%",
  boxSizing: "border-box",
  background: "#fff",
  borderBottom: embedded ? "1px solid #eee" : "none",
  boxShadow: embedded ? "0 2px 6px rgba(0,0,0,.04)" : "none",
  transition: "box-shadow 0.3s ease",
  padding: isMobile
    ? "env(safe-area-inset-top, 8px) 12px 6px"
    : `10px ${H_PADDING}px`,
}}>


  {!isMobile && !embedded && (
<div
  style={{
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    marginLeft: 56,
    marginRight: 16,
  }}
>
      <div style={{ position: "relative", display: "inline-flex", borderRadius: 12 }}>
        <div style={{
          position: "absolute", inset: -2, borderRadius: 14,
          background: "linear-gradient(90deg,#0a0a0a,#bf9b30,#d46b10,#e84020,#bf9b30,#0a0a0a)",
          backgroundSize: "300% 100%",
          animation: "aeSpin 3s linear infinite",
          zIndex: 0,
        }} />
        <div style={{ position: "relative", zIndex: 1, background: "#fff", borderRadius: 12, padding: 3, display: "inline-flex" }}>
          <img src={logoImg} alt="Areluxe" style={{ height: 34, width: 34, borderRadius: 10, objectFit: "cover", display: "block" }} />
        </div>
      </div>
    </div>
  )}

  <div style={styles.centerWrap}>   


    
          {/* ============ DESKTOP SEARCH ============ */}
          {!isMobile && (
            

            <div style={styles.searchAnchor}>
  <div style={styles.searchPill}>
            <SearchItem
  title="Where"
  subtitle={locationPreview}
  active={active === "where"}
  dimmed={isDimmed("where")}
  onClick={() => toggle("where")}
/>


              <Divider />

          <div
  onClick={() => toggle("dates")}
  style={{
    display: "flex",
    borderRadius: 999,
    background:
      active === "dates"
        ? "#fff"
        : isDimmed("dates")
        ? GREY_BG
        : "transparent",
    boxShadow: active === "dates"
      ? "0 6px 16px rgba(0,0,0,.18)"
      : "none",
    opacity: isDimmed("dates") ? 0.6 : 1,
    cursor: "pointer",
  }}
>
  <div style={{ ...styles.searchItem, boxShadow: "none" }}>
  <div style={styles.searchTitle}>Check in</div>
<div style={styles.searchSubtitle}>
  {whenPreview.checkIn}
</div>

  </div>

  <Divider />

  <div style={{ ...styles.searchItem, boxShadow: "none" }}>
  <div style={styles.searchTitle}>Check out</div>
<div style={styles.searchSubtitle}>
  {whenPreview.checkOut}
</div>

  </div>
</div>


              <Divider />

              {/* WHO wraps search button when active */}
        <div
  onClick={() => toggle("who")}
  style={{
    display: "flex",
    alignItems: "center",
    borderRadius: 999,
    background:
      active === "who"
        ? "#fff"
        : isDimmed("who")
        ? GREY_BG
        : "transparent",
    boxShadow:
      active === "who"
        ? "0 6px 16px rgba(0,0,0,.18)"
        : "none",
    opacity: isDimmed("who") ? 0.6 : 1,
    cursor: "pointer",
    position: "relative",
  }}
>
  <div style={{ ...styles.searchItem, boxShadow: "none" }}>
    <div style={styles.searchTitle}>Who</div>
    <div style={styles.searchSubtitle}>Add guests</div>
  </div>
  <button
  style={{ ...styles.searchBtn, marginRight: 8 }}
  onClick={(e) => {
    e.stopPropagation();
          toggle("who");

    applySearchFilters();
  }}
>
  <Search size={18} color="#fff" />
</button>

</div>


              {/*** +++++++++++++++++++++ MODALS ===== +++++++++++++++++++++*/}
          
              {/*** +++++++++++++++++++++ DESKTOP CALENDAR ===== +++++++++++++++++++++*/}

{active === "dates" && (
  <AnchorModal full>
    {/* ===== HEADER ===== */}
    <div
      style={{
        padding: "18px 28px",
        borderBottom: "1px solid rgba(0,0,0,0.08)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: "#fff",
      }}
    >
      <div style={{ display: "flex", gap: 10 }}>
{["dates", "months", "flex", "years"].map((key) => (
          <button
            key={key}
            onClick={() => setWhenMode(key as any)}
            style={{
              padding: "6px 14px",
              borderRadius: 9999,
              fontWeight: 700,
              fontSize: 14,
              border: "none",
              cursor: "pointer",
              background:
                whenMode === key
                  ? "linear-gradient(90deg,#FFD700,#B8860B)"
                  : "transparent",
              color: whenMode === key ? "#121212" : "#666",
            }}
          >
           {key === "dates"
  ? "Dates"
  : key === "months"
  ? "Months"
  : key === "flex"
  ? "Flexible"
  : "Years"}

          </button>
        ))}
      </div>

      <div style={{ fontWeight: 700, fontSize: 15, color: "#555" }}>
        {checkIn && checkOut
          ? `${checkIn.toLocaleDateString(undefined, {
              month: "short",
              day: "numeric",
            })} – ${checkOut.toLocaleDateString(undefined, {
              month: "short",
              day: "numeric",
            })}`
          : "Select dates"}
      </div>
    </div>

    {/* ===== BODY ===== */}
{whenMode === "dates" && (
  <div style={{ padding: "22px 28px" }}>
    {/* NAVIGATOR */}
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
      <button
        onClick={() => setMonthOffset((o) => Math.max(0, o - 1))}
        disabled={monthOffset === 0}
        style={{ ...styles.navBtn, opacity: monthOffset === 0 ? 0.3 : 1 }}
      >
        <ChevronLeft size={16} />
      </button>
      <button
        onClick={() => setMonthOffset((o) => o + 1)}
        style={styles.navBtn}
      >
        <ChevronRight size={16} />
      </button>
    </div>

    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32 }}>
      {[0, 1].map((m) => {
        const offset = monthOffset + m;  // ← use offset instead of m
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const base = new Date();
        base.setMonth(base.getMonth() + offset);  // ← offset here

        const monthName = base.toLocaleString(undefined, { month: "long", year: "numeric" });
        const daysInMonth = new Date(base.getFullYear(), base.getMonth() + 1, 0).getDate();
        const firstDay = new Date(base.getFullYear(), base.getMonth(), 1).getDay();

        const grid = [
          ...Array(firstDay).fill(null),
          ...Array.from({ length: daysInMonth }, (_, i) => i + 1),
        ];

        return (
          <div key={offset}>
            <div style={{ fontWeight: 700, marginBottom: 8, fontSize: 16 }}>{monthName}</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", textAlign: "center", fontSize: 13, color: "#666", marginBottom: 6 }}>
              {["S", "M", "T", "W", "T", "F", "S"].map((d) => <div key={d}>{d}</div>)}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 6 }}>
              {grid.map((day, i) => {
                if (day === null) return <div key={i} />;
                const date = new Date(base.getFullYear(), base.getMonth(), day);
                const past = date < today;
                const selected =
                  (checkIn && date.toDateString() === checkIn.toDateString()) ||
                  (checkOut && date.toDateString() === checkOut.toDateString());
                const inRange = checkIn && checkOut && date > checkIn && date < checkOut;

                return (
                  <div key={i} style={{ position: "relative" }}>
                    {inRange && <div style={{ position: "absolute", inset: 0, background: "rgba(255,215,0,0.2)", borderRadius: 8 }} />}
                    <button
                      disabled={past}
                      onClick={() => {
                        if (!checkIn || (checkIn && checkOut)) { setCheckIn(date); setCheckOut(null); }
                        else { if (date < checkIn) { setCheckOut(checkIn); setCheckIn(date); } else { setCheckOut(date); } }
                      }}
                      style={{
                        width: "100%", height: 38, borderRadius: 10, border: "none", fontWeight: 600,
                        cursor: past ? "not-allowed" : "pointer",
                        background: selected ? "linear-gradient(90deg,#FFD700,#B8860B)" : "transparent",
                        color: past ? "#ccc" : selected ? "#121212" : "#333",
                      }}
                    >
                      {day}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  </div>
)}

{/**************MONTHS MODE********************/}

    {whenMode === "months" && (
  <div style={{ padding: "32px 28px" }}>
    <h3 style={{ marginBottom: 20, fontSize: 18 }}>
      When do you want to go?
    </h3>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4,1fr)",
        gap: 16,
      }}
    >
      {Array.from({ length: 12 }).map((_, i) => {
        const month = new Date();
        month.setMonth(month.getMonth() + i);

        const isSelected = selectedMonth === i;

        return (
          <button
            key={i}
onClick={() => {
  setSelectedMonth(i);

  const today = dayjs();
  const targetMonth = dayjs().add(i, "month");

  let start = today;

  // if selected month is not current month → start from 1st
  if (i !== 0) {
    start = targetMonth.startOf("month");
  }

  const end = start.add(1, "month");

  setCheckIn(start.toDate());
  setCheckOut(end.toDate());
}}            style={{
              padding: "18px 0",
              borderRadius: 16,
              border: "1px solid #e5e5e5",
              fontWeight: 700,
              cursor: "pointer",
              background: isSelected
                ? "linear-gradient(135deg,#d4af37,#bfa14a)"
                : "#fff",
              color: isSelected ? "#121212" : "#333",
              boxShadow: isSelected
                ? "0 8px 18px rgba(0,0,0,.18)"
                : "none",
            }}
          >
            {month.toLocaleString(undefined, { month: "short" })}
          </button>
        );
      })}
    </div>
  </div>
)}


{/**************FLEXIBILE MODE********************/}
{whenMode === "flex" && (
  <div style={{ padding: "32px 28px" }}>
    <h3 style={{ marginBottom: 20, fontSize: 18 }}>
      How long do you want to stay?
    </h3>

    {/* LENGTH */}
    <div style={{ display: "flex", gap: 12, marginBottom: 28 }}>
      {(["Weekend", "Week", "Month"] as const).map((label) => {
        const isSelected = flexLength === label;

        return (
          <button
            key={label}
onClick={() => {
  setFlexLength(label);

  const start = dayjs();
  let end = start;

  if (label === "Weekend") end = start.add(2, "day");
  if (label === "Week") end = start.add(7, "day");
  if (label === "Month") end = start.add(1, "month");

  setCheckIn(start.toDate());
  setCheckOut(end.toDate());
}}

style={{
              padding: "14px 22px",
              borderRadius: 999,
              border: "1px solid #e5e5e5",
              fontWeight: 700,
              cursor: "pointer",
              background: isSelected
                ? "linear-gradient(135deg,#d4af37,#bfa14a)"
                : "#fff",
              color: isSelected ? "#121212" : "#333",
              boxShadow: isSelected
                ? "0 6px 14px rgba(0,0,0,.18)"
                : "none",
            }}
          >
            {label}
          </button>
        );
      })}
    </div>

    {/* MONTH */}
    <h3 style={{ marginBottom: 16, fontSize: 18 }}>When?</h3>

    <div style={{ display: "flex", gap: 12 }}>
      {["June", "July", "August"].map((label) => {
        const isSelected = flexMonth === label;

        return (
          <button
            key={label}
            onClick={() => setFlexMonth(label)}
            style={{
              padding: "14px 22px",
              borderRadius: 999,
              border: "1px solid #e5e5e5",
              fontWeight: 700,
              cursor: "pointer",
              background: isSelected
                ? "linear-gradient(135deg,#d4af37,#bfa14a)"
                : "#fff",
              color: isSelected ? "#121212" : "#333",
              boxShadow: isSelected
                ? "0 6px 14px rgba(0,0,0,.18)"
                : "none",
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  </div>
)}


{/*****+==============yeasr=================********/}
{whenMode === "years" && (
  <div style={{ padding: "32px 28px" }}>
    <h3 style={{ marginBottom: 20, fontSize: 18 }}>
      How many years?
    </h3>

    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
      <button
        onClick={() => updateYears(-1)}
        disabled={years === 1}
        style={{
          ...styles.guestBtn,
          opacity: years === 1 ? 0.4 : 1,
        }}
      >
        <Minus size={16} />
      </button>

      <input
        type="number"
        min={1}
        value={years}
        onChange={(e) =>
          setYears(Math.max(1, Number(e.target.value)))
        }
        style={{
          width: 100,
          textAlign: "center",
          fontSize: 20,
          fontWeight: 700,
          padding: 10,
          borderRadius: 14,
          border: "1px solid #ddd",
        }}
      />

      <button
        onClick={() => updateYears(1)}
        style={styles.guestBtn}
      >
        <Plus size={16} />
      </button>
    </div>
  </div>
)}



  </AnchorModal>
)}




              {/*** +++++++++++++++++++++ DESKTOP WHERE ===== +++++++++++++++++++++*/}


{active === "where" && (
  <AnchorModal small left>
    <div style={{ width: 320 }}>
         <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <div style={{ fontWeight: 700, fontSize: 16 }}>
          Where
        </div>

        <button
          onClick={clearAllFilters}
          style={{
            background: "transparent",
            border: "none",
            fontSize: 13,
            fontWeight: 600,
            textDecoration: "underline",
            cursor: "pointer",
            color: "#555",
          }}
        >
          Clear
        </button>
      </div>

      <TextField
        fullWidth
        inputRef={inputRef}              // ✅ ADD
        value={locationText}             // ✅ ADD
        onChange={(e) => setLocationText(e.target.value)} // ✅ ADD
        label="Search destinations"
        placeholder="Search destinations"
        variant="outlined"
        InputLabelProps={{ style: { fontWeight: 600 } }}
        inputProps={{ style: { padding: "14px", fontSize: 14 } }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "14px",
            backgroundColor: "#fff",
          },
        }}
      />
      {suggestions.length > 0 && (
  <div style={{ marginTop: 12 }}>
    {suggestions.map((loc) => {
      const label = [
        loc.neighborhood,
        loc.city,
        loc.country,
      ].filter(Boolean).join(", ");

      return (
        <div
          key={loc.id}
          onClick={() => {
            setLocationText(label);

         dispatch(
              setFilters({
                address: {
                  neighborhood: loc.neighborhood || null,
                  city: loc.city || null,
                  country: loc.country || null,
                  latitude: null,
                  longitude: null,
                  bounds: null,
                },
              })
            );

            setSuggestions([]);
            setActive("dates");
            setOpenCard("when");
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "10px 12px",
            borderRadius: 12,
            cursor: "pointer",
            transition: "background .2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
        >
          {/* ICON */}
       <div
  style={{
    width: 36,
    height: 36,
    borderRadius: "50%",
    background: "#eee",
    display: "grid",
    placeItems: "center",
  }}
>
  <MapPin size={18} color="#555" />
</div>


          {/* TEXT */}
          <div>
<div style={{ fontWeight: 700, fontSize: 14 }}>
  {[loc.neighborhood, loc.city].filter(Boolean).join(", ")}
</div>
<div style={{ fontSize: 12, color: "#777" }}>
  {loc.country}
</div>
          </div>
        </div>
      );
    })}
  </div>
)}


      <div style={{ height: 24 }} />
    </div>
  </AnchorModal>
)}



              {/*** +++++++++++++++++++++ DESKTOP WHO ===== +++++++++++++++++++++*/}

            {active === "who" && (
  <AnchorModal small right>
    <div style={{ width: 320 }}>
      {[
        {
          key: "adults",
          label: "Adults",
          desc: "Ages 13 or above",
        },
        {
          key: "children",
          label: "Children",
          desc: "Ages 2–12",
        },
        {
          key: "infants",
          label: "Infants",
          desc: "Under 2",
        },
        {
          key: "pets",
          label: "Pets",
          desc: "Bringing a service animal?",
          muted: true,
        },
      ].map(({ key, label, desc, muted }) => {
        const value = guests[key as keyof typeof guests];

        return (
          <div
            key={key}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "14px 0",
              borderBottom:
                key !== "pets" ? "1px solid #eee" : "none",
            }}
          >
            {/* LEFT */}
            <div>
              <div style={{ fontWeight: 700 }}>{label}</div>
              <div
                style={{
                  fontSize: 13,
                  color: muted ? "#999" : "#777",
                }}
              >
                {desc}
              </div>
            </div>

            {/* RIGHT */}
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <button
                onClick={() =>
                  updateGuest(key as any, -1)
                }
                disabled={value === 0}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  border: "1px solid #ccc",
                  background: "#fff",
                  fontSize: 18,
                  cursor: value === 0 ? "not-allowed" : "pointer",
                  opacity: value === 0 ? 0.4 : 1,
                }}
              >
                −
              </button>

              <div
                style={{
                  width: 20,
                  textAlign: "center",
                  fontWeight: 600,
                }}
              >
                {value}
              </div>

              <button
                onClick={() =>
                  updateGuest(key as any, 1)
                }
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  border: "1px solid #ccc",
                  background: "#fff",
                  fontSize: 18,
                  cursor: "pointer",
                }}
              >
                +
              </button>
            </div>
          </div>
        );
      })}
    </div>
  </AnchorModal>
)}

</div>
            </div>
          )}

          

{/* ============ MOBILE SEARCH ============ */}
{isMobile && (
  <section
    style={{
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "10px 12px",
      overflow: "hidden",
      position: "sticky",
      top: 70,
      zIndex: 199,
      background: "#fff",
    }}
  >


{/* ===== MOBILE LOGO ===== */}
<div style={{ position: "relative", display: "inline-flex", borderRadius: 8, flexShrink: 0 }}>
  <div style={{
    position: "absolute", inset: -2, borderRadius: 10,
    background: "linear-gradient(90deg,#0a0a0a,#bf9b30,#d46b10,#e84020,#bf9b30,#0a0a0a)",
    backgroundSize: "300% 100%",
    animation: "aeSpin 3s linear infinite",
    zIndex: 0,
  }} />
  <div style={{ position: "relative", zIndex: 1, background: "#fff", borderRadius: 8, padding: 2, display: "inline-flex" }}>
    <img src={logoImg} alt="Areluxe" style={{ height: 28, width: 28, borderRadius: 6, objectFit: "cover", display: "block" }} />
  </div>
</div>

{/* ===== CLEAN SINGLE PILL ===== */}
<div
  onClick={() => toggle("mobile")}
  style={{
    flex: 1,
    display: "flex",
    alignItems: "center",
    gap: 8,
    borderRadius: 999,
    border: "1px solid #ddd",
    background: "#fff",
    padding: "8px 60px",
    cursor: "pointer",
    boxShadow: "0 3px 0px #c8c8c8, 0 4px 8px rgba(0,0,0,0.10)",
    transition: "box-shadow .15s, transform .15s",
    transform: "translateY(0)",
    minHeight: 50,
  }}
      onPointerDown={(e) => {
        (e.currentTarget as HTMLDivElement).style.boxShadow = "0 2px 0px #c8c8c8, 0 3px 8px rgba(0,0,0,0.10)";
        (e.currentTarget as HTMLDivElement).style.transform = "translateY(3px)";
      }}
      onPointerUp={(e) => {
        (e.currentTarget as HTMLDivElement).style.boxShadow = "0 6px 0px #c8c8c8, 0 8px 16px rgba(0,0,0,0.12)";
        (e.currentTarget as HTMLDivElement).style.transform = "translateY(0)";
      }}
    >
   <Search size={15} color="#d4af37" strokeWidth={2.5} />
<span style={{ fontSize: 13, fontWeight: 700, color: "#444" }}>
  Search Destinations
</span>
    </div>

    {/* 🔔 MOBILE NOTIFICATION */}
    {isAuthenticated && (
      <button
        style={styles.notificationBtn}
        onClick={() => navigate(`/notifications/${user?.userId}`)}
      >
        <Bell size={18} />
        {unreadCount > 0 && (
          <span style={styles.notificationBadge}>
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>
    )}

    
    {/* ===== FULL SCREEN SHEET ===== */}
    {active === "mobile" && (
      <div style={{ position: "fixed", inset: 0, zIndex: 9999 }}>
        {/* blurred backdrop — tap to close */}
        <div
          onClick={() => setActive(null)}
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
          }}
        />
        <div style={styles.mobileSheet}>

          {/* SHEET HEADER */}
          <div style={styles.sheetHeader}>
            <div style={{ fontWeight: 700 }}>Search</div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 6 }}>
              <button
                onClick={() => setActive(null)}
                style={{
                  padding: "6px 14px", borderRadius: 999,
                  border: "1px solid #E51E24", background: "#E51E24",
                  color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer",
                  boxShadow: "0 2px 6px rgba(229,30,36,.35)",
                }}
              >
                Close
              </button>
              <button
                type="button"
                style={{
                  background: "transparent", border: "none", padding: 0,
                  color: "#444", fontSize: 13, fontWeight: 600,
                  textDecoration: "underline", cursor: "pointer",
                }}
                onClick={clearAllFilters}
              >
                Clear
              </button>
            </div>
          </div>

          {/* ========== DESTINATION CARD ========== */}
          <MobileExpandableCard
            id="where"
            title="Destination"
            preview={locationPreview || "I'm flexible"}
            openCard={openCard}
            setOpenCard={setOpenCard}
          >
            <TextField
              fullWidth
              inputRef={inputRef}
              value={locationText}
              onChange={(e) => setLocationText(e.target.value)}
              placeholder="Search destinations"
              variant="outlined"
            />
            {suggestions.length > 0 && (
              <div style={{ marginTop: 12 }}>
                {suggestions.map((loc) => {
                  const label = [loc.neighborhood, loc.city, loc.country].filter(Boolean).join(", ");
                  return (
                    <div
                      key={loc.id}
                      onClick={() => {
                        setLocationText(label);
                        dispatch(setFilters({
                          address: {
                            neighborhood: loc.neighborhood || null,
                            city: loc.city || null,
                            country: loc.country || null,
                            latitude: null,
                            longitude: null,
                            bounds: null,
                          },
                        }));
                        setSuggestions([]);
                        setOpenCard("when");
                      }}
                      style={{
                        display: "flex", alignItems: "center", gap: 12,
                        padding: "10px 12px", borderRadius: 12, cursor: "pointer", transition: "background .2s",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                    >
                      <div style={{ width: 36, height: 36, borderRadius: "50%", background: "#eee", display: "grid", placeItems: "center", flexShrink: 0 }}>
                        <MapPin size={18} color="#555" />
                      </div>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 14 }}>{loc.city || loc.neighborhood}</div>
                        <div style={{ fontSize: 12, color: "#777" }}>{loc.country}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </MobileExpandableCard>

          {/* ========== WHEN CARD ========== */}
          <MobileExpandableCard
            id="when"
            title="When"
            preview={whenPreview.range}
            openCard={openCard}
            setOpenCard={setOpenCard}
          >
            <div style={styles.whenToggle}>
              {["dates", "months", "flex", "years"].map((m) => (
                <button
                  key={m}
                  onClick={() => setWhenMode(m as any)}
                  style={{
                    ...styles.whenToggleBtn,
                    background: whenMode === m ? "linear-gradient(90deg,#FFD700,#B8860B)" : "transparent",
                  }}
                >
                  {m === "dates" ? "Dates" : m === "months" ? "Months" : m === "flex" ? "Flexible" : "Years"}
                </button>
              ))}
            </div>

            {whenMode === "dates" && (
              <MobileCalendar checkIn={checkIn} checkOut={checkOut} setCheckIn={setCheckIn} setCheckOut={setCheckOut} />
            )}

            {whenMode === "months" && (
              <div style={styles.monthGrid}>
                {Array.from({ length: 12 }).map((_, i) => {
                  const m = new Date(); m.setMonth(m.getMonth() + i);
                  const selected = selectedMonth === i;
                  return (
                    <button
                      key={i}
                      onClick={() => {
                        setSelectedMonth(i);
                        const today = dayjs();
                        const targetMonth = dayjs().add(i, "month");
                        const start = i !== 0 ? targetMonth.startOf("month") : today;
                        const end = start.add(1, "month");
                        setCheckIn(start.toDate());
                        setCheckOut(end.toDate());
                      }}
                      style={{
                        ...styles.monthBtn,
                        background: selected ? "linear-gradient(135deg,#d4af37,#bfa14a)" : "#fff",
                      }}
                    >
                      {m.toLocaleString(undefined, { month: "short" })}
                    </button>
                  );
                })}
              </div>
            )}

            {whenMode === "flex" && (
              <div style={{ display: "flex", gap: 12 }}>
                {["Weekend", "Week", "Month"].map((f) => (
                  <button
                    key={f}
                    onClick={() => setFlexLength(f as any)}
                    style={{
                      ...styles.flexBtn,
                      background: flexLength === f ? "linear-gradient(135deg,#d4af37,#bfa14a)" : "#fff",
                    }}
                  >
                    {f}
                  </button>
                ))}
              </div>
            )}

            {whenMode === "years" && (
              <div style={{ padding: "16px 0" }}>
                <h3 style={{ marginBottom: 16, fontSize: 18 }}>How many years?</h3>
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  <button onClick={() => updateYears(-1)} disabled={years === 1} style={{ ...styles.guestBtn, opacity: years === 1 ? 0.4 : 1 }}>
                    <Minus size={16} />
                  </button>
                  <input
                    type="number" min={1} value={years}
                    onChange={(e) => setYears(Math.max(1, Number(e.target.value)))}
                    style={{ width: 80, textAlign: "center", fontSize: 18, fontWeight: 700, padding: 8, borderRadius: 12, border: "1px solid #ddd" }}
                  />
                  <button onClick={() => updateYears(1)} style={styles.guestBtn}><Plus size={16} /></button>
                </div>
              </div>
            )}
          </MobileExpandableCard>

          {/* ========== ADD GUESTS CARD ========== */}
          <MobileExpandableCard
            id="who"
            title="Add Guests"
            preview={guestsPreview}
            openCard={openCard}
            setOpenCard={setOpenCard}
          >
            {[
              ["adults", "Adults", "Ages 13+"],
              ["children", "Children", "Ages 2–12"],
              ["infants", "Infants", "Under 2"],
              ["pets", "Pets", "Service animals?"],
            ].map(([key, label, desc]) => (
              <div key={key} style={styles.guestRow}>
                <div>
                  <div style={{ fontWeight: 700 }}>{label}</div>
                  <div style={{ fontSize: 13, color: "#777" }}>{desc}</div>
                </div>
                <div style={styles.counterRow}>
                  <button
                    style={{ ...styles.guestBtn, opacity: guests[key as keyof typeof guests] === 0 ? 0.4 : 1 }}
                    disabled={guests[key as keyof typeof guests] === 0}
                    onClick={() => updateGuest(key as any, -1)}
                  >
                    <Minus size={16} />
                  </button>
                  <span style={{ minWidth: 20, textAlign: "center", fontWeight: 600 }}>
                    {guests[key as keyof typeof guests]}
                  </span>
                  <button style={styles.guestBtn} onClick={() => updateGuest(key as any, 1)}>
                    <Plus size={16} />
                  </button>
                </div>
              </div>
            ))}
          </MobileExpandableCard>

          {/* ========== SEARCH BUTTON ========== */}
          <button
  style={{
    ...styles.mobileSearchBtn,
    padding: "10px 28px",
    fontSize: 14,
    fontWeight: 700,
    borderRadius: 999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    width: "auto",
    alignSelf: "center",
    margin: "12px auto 0",
  }}
  onClick={applySearchFilters}
>
  <Search size={15} color="#fff" />
  Search
</button>

        </div>
      </div>
)}
  </section>

)}



        </div>

{!isMobile && !embedded && (
  <div style={{ display: "flex", alignItems: "center", gap: 12, marginRight: 56 }}>

    
        <button
      onClick={() => navigate(isAuthenticated ? `/onboarding/${user?.userId}` : "/AuthSwitch")}
      style={{
        position: "relative", display: "inline-flex", alignItems: "center", gap: 8,
        background: "#0a0a0a", color: "#fff", border: "none", borderRadius: 40,
        padding: "11px 22px", fontWeight: 700, fontSize: 13, cursor: "pointer",
        overflow: "hidden", zIndex: 0,
      }}
    >
      <span style={{
        position: "absolute", inset: -2, borderRadius: 42,
        background: "linear-gradient(90deg,#0a0a0a,#bf9b30,#d46b10,#e84020,#bf9b30,#0a0a0a)",
        backgroundSize: "300% 100%", animation: "aeSpin 3s linear infinite", zIndex: -1,
      }} />
      <span style={{ position: "absolute", inset: 2, borderRadius: 38, background: "#0a0a0a", zIndex: -1 }} />
      Become a Host
    </button>


{isAuthenticated && (
  <button
    style={styles.notificationBtn}
    onClick={() => navigate(`/notifications/${user?.userId}`)}
  >
    <Bell size={18} />

    {unreadCount > 0 && (
      <span style={styles.notificationBadge}>
        {unreadCount > 99 ? "99+" : unreadCount}
      </span>
    )}
  </button>
)}



    {/* PROFILE MENU BUTTON */}
    <button
      style={styles.profileMenuBtn}
      onClick={() => {
        if (!isAuthenticated) {
          navigate("/AuthSwitch");
        } else {
          toggle("menu");
        }
      }}
      onMouseDown={(e) => {
        e.currentTarget.style.transform = "translateY(1px)";
        e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,.15)";
      }}
      onMouseUp={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,.12)";
      }}
    >
      {isAuthenticated ? (
        <img
          src={user?.profilePicture || logoImg}
          alt={user?.firstName || "Profile"}
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).onerror = null;
            (e.currentTarget as HTMLImageElement).src = logoImg;
          }}
          style={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      ) : (
        <User size={18} />
      )}

      <Menu size={18} />
    </button>
  </div>
)}


  </section>

{/* spacer so content doesn't hide under fixed header */}
{/* spacer so content doesn't hide under fixed header */}
{!embedded && <div style={{ height: isMobile ? 56 : headerHeight }} />}
<div style={styles.separator} />




            {/* ================= MOBILE SUBHEADER ================= */}

{isMobile && (
  <section
    style={{
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "10px 12px",
      overflow: "hidden",
      position: embedded ? "sticky" : "fixed",
      top: embedded ? 0 : 60,
      left: embedded ? "auto" : 0,
      right: embedded ? "auto" : 0,
      zIndex: embedded ? 9 : 199,
      background: "#fff",
      borderBottom: "1px solid #eee",
    }}
  >


    {/* FILTER */}
    <button
      style={styles.filtersBtn}
      onClick={() => toggle("filters")}
    >
      <Tune fontSize="small" />
    </button>

    {/* CATEGORIES (SCROLLABLE) */}
    <div
      style={{
        flex: 1,
        overflowX: "auto",
        display: "flex",
        gap: 14,
        scrollbarWidth: "none",
      }}
    >
      {propertyCategories.map((cat) => {
        const isSelected = selectedCategoryId === cat.id;

        return (
          <button
            key={cat.id}
onClick={() => {
  const next =
    selectedCategoryId === cat.id ? null : cat.id;

  setSelectedCategoryId(next);

  dispatch(
    setFilters({
      ...filters,
      category: next,
    })
  );
}}

            style={{
              minWidth: 72, // 👈 ensures ~2 visible
              padding: "6px 4px",
              border: "none",
              background: "transparent",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              opacity: isSelected ? 1 : 0.65,
            }}
          >
            {/* ICON */}
          <div
            style={{
              fontSize: 18,
              marginBottom: 4,
              color: isSelected ? "#d4af37" : "#777",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {cat.image ? (
              <img
                src={cat.image}
                alt={cat.name}
                width={40}
                  height={40}
                style={{ objectFit: "contain" }}
              />
            ) : (
              cat.icon
            )}
          </div>


            {/* LABEL */}
            <div
              style={{
                fontSize: 11,
                fontWeight: isSelected ? 700 : 600,
                whiteSpace: "nowrap",
                background: isSelected ? LUXURY_GRADIENT : "none",
                WebkitBackgroundClip: isSelected ? "text" : undefined,
                WebkitTextFillColor: isSelected
                  ? "transparent"
                  : undefined,
                color: isSelected ? undefined : "#555",
              }}
            >
              {cat.name}
            </div>

            {/* UNDERLINE */}
            <div
              style={{
                marginTop: 4,
                height: 2,
                width: "100%",
                borderRadius: 2,
                background: isSelected
                  ? LUXURY_GRADIENT
                  : "transparent",
              }}
            />
          </button>
        );
      })}
    </div>

    </section>
)}

{isMobile && !embedded && <div style={{ height: 56 }} />}


<div style={styles.separator} />

      {/* ================= DESKTOP CATEGORIES ================= */}
      
      {!isMobile && (
        <>
          <div style={styles.separator} />
     <section style={{
       ...styles.categoriesRow,
       position: embedded ? "sticky" : "fixed",
       top: embedded ? 0 : headerHeight,
       left: embedded ? "auto" : 0,
       right: embedded ? "auto" : 0,
       zIndex: embedded ? 9 : 199,
       width: "100%",
       boxSizing: "border-box",
       padding: `8px ${H_PADDING}px`,
       background: "#fff",
     }}>



  {/* LEFT: scrollable categories */}
  <div style={styles.categoriesWrap}>
   <button
  style={styles.navBtn}
  onClick={() => scrollCategories("left")}
>
  <ChevronLeft size={16} />
</button>


<div
  ref={categoriesScrollRef}
  style={styles.categoriesScroll}
>
      {propertyCategories.map((cat) => {
        const isSelected = selectedCategoryId === cat.id;

        return (
  <button
  key={cat.id}
onClick={() => {
  const next =
    selectedCategoryId === cat.id ? null : cat.id;

  setSelectedCategoryId(next);

  dispatch(
    setFilters({
      ...filters,
      category: next,
    })
  );
}}

  style={{
    ...styles.categoryItem,
    opacity: isSelected ? 1 : 0.6,
  }}
>
  {/* ICON */}
<div
  style={{
    fontSize: 18,
    marginBottom: 4,
    color: isSelected ? "#d4af37" : "#777",
    display: "flex",
    justifyContent: "center",
  }}
>
  {cat.image ? (
    <img
      src={cat.image}
      alt={cat.name}
      width={40}
      height={40}
      style={{ objectFit: "contain" }}
    />
  ) : (
    cat.icon
  )}
</div>


  {/* LABEL */}
  <div
    style={{
      fontWeight: isSelected ? 700 : 600,

      // 🎯 gradient text
      background: isSelected ? LUXURY_GRADIENT : "none",
      WebkitBackgroundClip: isSelected ? "text" : undefined,
      WebkitTextFillColor: isSelected ? "transparent" : undefined,
      color: isSelected ? undefined : "#555",
    }}
  >
    {cat.name}
  </div>

  {/* UNDERLINE */}
  <div
    style={{
      marginTop: 6,
      height: 2,
      width: "100%",
      borderRadius: 2,
      background: isSelected ? LUXURY_GRADIENT : "transparent",
      transition: "background .25s ease",
    }}
  />
</button>

        );
      })}
    </div>

   <button
  style={styles.navBtn}
  onClick={() => scrollCategories("right")}
>
  <ChevronRight size={16} />
</button>

  </div>

  {/* RIGHT: fixed controls */}
  <div style={styles.rightControls}>
    <button
      style={styles.filtersBtn}
      onClick={() => toggle("filters")}
    >
      <Tune fontSize="small" /> Filters
    </button>
  </div>
</section>

      <div style={{ height: 30 }} />
        

        </>
      )}




{/* ================= EARLY HOSTS / PIONEER CTA ================= */}
{showPioneerSection ? (
  <div style={{ ...styles.topHostsSection, marginTop: isMobile ? 26 : 52, position: "relative" }}>

    <button
      onClick={() => setShowPioneerSection(false)}
      style={styles.pioneerCollapseBtn}
      aria-label="Hide this section"
    >
      <ChevronUp size={16} />
    </button>

    {topEarlyHostListings.length > 0 ? (
      <>
        <div style={styles.topHostsHeaderGradient}>Early hosts near you</div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile
              ? "repeat(2, 1fr)"
              : "repeat(auto-fill, minmax(300px, 1fr))",
            gap: isMobile ? 10 : 20,
            marginTop: 14,
          }}
        >
          {topEarlyHostListings.map((stay) => (
            <ListingCard
              key={stay.listingId}
              stay={stay}
              userId={user?.userId}
              wishlist={wishlist}
              currencyProps={{ rate: 1, symbol: "", currency: "" }}
              checkIn={checkIn ? dayjs(checkIn).format("YYYY-MM-DD") : null}
              checkOut={checkOut ? dayjs(checkOut).format("YYYY-MM-DD") : null}
              guests={guests.adults + guests.children + guests.infants + guests.pets}
            />
          ))}
        </div>
      </>
    ) : (
      <div style={{ textAlign: "center" }}>
        <img
          src={pioneerBadgeImg}
          alt="Pioneer Host"
          style={{
            width: 120,
            height: 120,
            objectFit: "contain",
            margin: "0 auto 16px",
            display: "block",
          }}
        />
        <div style={styles.pioneerCtaText}>
          Be a Pioneer host in your city and benefit from exclusive benefits
        </div>
      </div>
    )}
  </div>
) : (
  <button
    onClick={() => setShowPioneerSection(true)}
    style={styles.pioneerReopenBtn}
    aria-label="Show pioneer hosts section"
  >
    <ChevronDown size={14} />
  </button>
)}



        {/* ================= LISTINGS GRID ================= */}
{initialLoad ? (
  <div style={{ ...styles.listingsGrid, paddingTop: isMobile ? 26 : 52 }}>
    {Array.from({ length: 8 }).map((_, i) => (
      <ListingSkeletonCard key={`sk-${i}`} />
    ))}
  </div>
) : visibleListings && visibleListings.length > 0 ? (
  <div style={{ ...styles.listingsGrid, paddingTop: isMobile ? 26 : 52 }}>
    {visibleListings.map((stay, index) => (
      <div
        key={stay.listingId}
        style={{
          animation: "cardRiseIn 0.5s ease forwards",
          animationDelay: `${(index % BATCH_SIZE) * 90}ms`,
          opacity: 0,
        }}
      >
        <ListingCard
          stay={stay}
          userId={user?.userId}
          wishlist={wishlist}
          //currencyProps={{ rate, symbol, currency }}
          currencyProps={{ rate: 1, symbol: "", currency: "" }}
          checkIn={checkIn ? dayjs(checkIn).format("YYYY-MM-DD") : null}
          checkOut={checkOut ? dayjs(checkOut).format("YYYY-MM-DD") : null}
          guests={
            guests.adults +
            guests.children +
            guests.infants +
            guests.pets
          }
        />
      </div>
    ))}
  </div>
) : (
<div
  style={{
    display: "flex",
    justifyContent: "center",
    width: "100%",
    boxSizing: "border-box",
    padding: isMobile ? "26px 20px 60px" : "52px 20px 60px",
  }}
>
  <div
    style={{
      background: "#E50914", // 🔥 Netflix red
      color: "#fff",
      padding: "22px 32px",
      borderRadius: 6,
      minWidth: 280,
      maxWidth: 420,
      textAlign: "center",
      fontWeight: 700,
      fontSize: 16,
      letterSpacing: 0.2,
      boxShadow: "0 10px 30px rgba(229,9,20,0.45)",
    }}
  >
    <div>No listings found</div>

    {/* VIEW ALL LISTINGS */}
<button
  onClick={() => {
    clearAllFilters();        // redux + search filters

    setAmenitiesFilter([]);   // modal filters
    setPriceRange({
      min: 0,
      max: maxListingPrice,
    });

    setSelectedCategoryId(null);
    setRateTypeFilter("any");
  }}
  style={{
    marginTop: 12,
    background: "transparent",
    border: "none",
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    textDecoration: "underline",
    cursor: "pointer",
  }}
>
  View all listings
</button>
  </div>
</div>
)}
{!initialLoad && isLoadingMore && <LoadingMoreDots />}

{/* ================= FILTER MODAL ================= */}


{active === "filters" && (
  <div
    onClick={() => setActive(null)}
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 20000,
      background: "rgba(0,0,0,0.45)",
      backdropFilter: "blur(4px)",
      display: "flex",
      justifyContent: "center",
      alignItems: isMobile ? "flex-end" : "center",
      padding: isMobile ? 0 : 20,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: isMobile ? "100%" : 720,
        maxWidth: "92vw",
        background: "#fff",
        borderRadius: isMobile ? "24px 24px 0 0" : 22,
        padding: isMobile ? "22px 20px 100px" : 28, // 👈 bottom space for mobile
        boxShadow: "0 30px 70px rgba(0,0,0,.35)",
        maxHeight: "85vh",
        overflowY: "auto",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <div style={{ fontWeight: 800, fontSize: 18 }}>
          Filters
        </div>

        <button
          onClick={() => setActive(null)}
          style={{
            border: "none",
            background: "#f3f3f3",
            width: 34,
            height: 34,
            borderRadius: "50%",
            cursor: "pointer",
          }}
        >
          <X size={16} />
        </button>
      </div>

      {/* GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: 30,
        }}
      >
        {/* ================= PRICE ================= */}
        <div>
          <div style={{ fontWeight: 700, marginBottom: 12 }}>
            Price per night
          </div>

          <div
            style={{
              fontWeight: 600,
              marginBottom: 14,
            }}
          >
            {symbol}
            {priceRange.min.toLocaleString()} — {symbol}
            {priceRange.max.toLocaleString()}
          </div>

          <input
            type="range"
            min={0}
            max={maxListingPrice}
            value={priceRange.max}
            onChange={(e) =>
              setPriceRange({
                ...priceRange,
                max: Number(e.target.value),
              })
            }
            style={{ width: "100%", marginBottom: 14 }}
          />

          <div
            style={{
              display: "flex",
              gap: 10,
            }}
          >
            <button
              onClick={() =>
                setPriceRange((p) => ({
                  ...p,
                  min: Math.max(0, p.min - 10),
                }))
              }
              style={{
                flex: 1,
                padding: 10,
                borderRadius: 10,
                border: "1px solid #ddd",
                background: "#fff",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              <Minus size={16} />
            </button>

            <button
              onClick={() =>
                setPriceRange((p) => ({
                  ...p,
                  max: Math.min(maxListingPrice, p.max + 10),
                }))
              }
              style={{
                flex: 1,
                padding: 10,
                borderRadius: 10,
                border: "1px solid #ddd",
                background: "#fff",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              <Plus size={16} />
            </button>
          </div>
        </div>

        {/* ================= AMENITIES ================= */}
        <div>
          <div style={{ fontWeight: 700, marginBottom: 12 }}>
            Amenities
          </div>

          <div
            style={{
              maxHeight: 260,
              overflowY: "auto",
            }}
          >
            {allowedAmenities.map((item) => {
              const selected = amenitiesFilter.includes(item.id);

              return (
                <div
                  key={item.id}
                  onClick={() => {
                    setAmenitiesFilter((prev) =>
                      prev.includes(item.id)
                        ? prev.filter((id) => id !== item.id)
                        : [...prev, item.id]
                    );
                  }}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 0",
                    borderBottom: "1px solid #eee",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                   {SHOW_AMENITY_IMAGES && item.image ? (
  <img
    src={item.image}
    alt={item.name}
    width={26}
    height={26}
    style={{ objectFit: "contain" }}
  />
) : (
  item.icon
)}
                    <span>{item.name}</span>
                  </div>

                  <input
                    type="checkbox"
                    checked={selected}
                    readOnly
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>



   {/* ================= DISPLAY TOTAL BEFORE TAX ================= */}
      <div style={{ marginTop: 24 }}>
        <TaxToggle taxOn={taxOn} setTaxOn={setTaxOn} />
      </div>

      {/* ================= RATE TYPE ================= */}
<div style={{ marginTop: 24 }}>
  <div style={{ fontWeight: 700, marginBottom: 12 }}>
    Rate Type
  </div>

  <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
    {[
      { key: "any", label: "Any" },
      { key: "perNight", label: "Per Night" },
      { key: "perNightPerPerson", label: "Per Night · Person" },
      { key: "perHour", label: "Per Hour" },
      { key: "perHourPerPerson", label: "Per Hour · Person" },
      { key: "perWeek", label: "Weekly" },
      { key: "perMonth", label: "Monthly" },
      { key: "perYear", label: "Yearly" },
    ].map((opt) => {
      const isSelected = rateTypeFilter === opt.key;
      return (
        <div
          key={opt.key}
          onClick={() => setRateTypeFilter(opt.key as any)}
          style={{
            position: "relative",
            borderRadius: 999,
            padding: isSelected ? 2 : 0,
            background: isSelected
              ? "linear-gradient(90deg,#0a0a0a,#bf9b30,#d46b10,#e84020,#bf9b30,#0a0a0a)"
              : "transparent",
            backgroundSize: isSelected ? "300% 100%" : undefined,
            animation: isSelected ? "aeSpin 3s linear infinite" : "none",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              padding: "8px 16px",
              borderRadius: 999,
              border: isSelected ? "none" : "1px solid #ddd",
              background: isSelected ? "#fff" : "#fff",
              fontWeight: isSelected ? 700 : 500,
              fontSize: 13,
              color: isSelected ? "#000" : "#444",
              whiteSpace: "nowrap",
            }}
          >
            {opt.label}
          </div>
        </div>
      );
    })}
  </div>
</div>

      {/* ================= CANCELLATION POLICY ================= */}
<div style={{ marginTop: 24 }}>
  <div style={{ fontWeight: 700, marginBottom: 12 }}>
    Cancellation Policy
  </div>

  {[
    { key: "any",     label: "Any policy" },
    { key: "free",    label: "Free cancellation" },
    { key: "partial", label: "Partial refund" },
    { key: "system",  label: "System default" },
  ].map((opt) => {
    const isSelected = cancellationFilter === opt.key;
    return (
      <div
        key={opt.key}
        onClick={() => setCancellationFilter(opt.key as any)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 0",
          borderBottom: "1px solid #eee",
          cursor: "pointer",
        }}
      >
        <span style={{
          fontWeight: isSelected ? 700 : 500,
          color: isSelected ? "#E50914" : "#222",
        }}>
          {opt.label}
        </span>
        <div style={{
          width: 18,
          height: 18,
          borderRadius: "50%",
          border: `2px solid ${isSelected ? "#E50914" : "#ccc"}`,
          background: isSelected ? "#E50914" : "transparent",
        }} />
      </div>
    );
  })}
</div>

      {/* FOOTER */}
      <div
        style={{
          marginTop: 30,
          display: "flex",
          gap: 12,
          justifyContent: "flex-end",
        }}
      >
        <button
          onClick={() => {
            setAmenitiesFilter([]);
            setPriceRange({
              min: 0,
              max: maxListingPrice,
            });
          }}
          style={{
            padding: "12px 18px",
            borderRadius: 12,
            border: "1px solid #ddd",
            background: "#fff",
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Clear
        </button>

        <button
          onClick={() => setActive(null)}
          style={{
            padding: "12px 22px",
            background: "#E50914",
            color: "#fff",
            border: "none",
            borderRadius: 12,
            fontWeight: 800,
            cursor: "pointer",
            boxShadow: "0 8px 20px rgba(229,9,20,.4)",
          }}
        >
          Apply
        </button>
      </div>
    </div>
  </div>
)}











       
 {/*}================= SIDE MENU ================= */}
   {active === "menu" && (
  <div
    style={styles.sidebarOverlay}
    onClick={() => setActive(null)}
  >
    <div
      style={styles.sidebar}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        style={styles.closeBtn}
        onClick={() => setActive(null)}
      >
        <X size={18} />
      </button>

      <div style={styles.sidebarContent}>
        {isAuthenticated ? (
          <>
            <button onClick={() => navigate(`/ShortBookingsDashboard/${user?.userId}`)} style={styles.sidebarItem}>
              Resevations
            </button>
            <button onClick={() => navigate(`/wishlist/${user?.userId}`)} style={styles.sidebarItem}>
              Wishlists
            </button>

            <button onClick={() => navigate(`/notifications/${user?.userId}`)} style={styles.sidebarItem}>
              Notifications
            </button>

            <button onClick={() => navigate("/imessagepreview/")} style={styles.sidebarItem}>
              Messages
            </button>

            <button onClick={() => navigate(`/profile/${user?.userId}`)} style={styles.sidebarItem}>
              Profile
            </button>

            <button onClick={() => navigate(`/dashboard/${user?.userId}`)} style={styles.sidebarItem}>
              Dashboard
            </button>

            <button onClick={() => navigate(`/profileSettings/${user?.userId}`)} style={styles.sidebarItem}>
              Account Settings
            </button>

            <button onClick={() => navigate("/CurrencySelection")} style={styles.sidebarItem}>
              Language & Currency
            </button>

           <button onClick={() => navigate("/CustomerSupport")} style={styles.sidebarItem}>
Help            
</button>
     <button
              onClick={handleLogout}
              style={styles.sidebarItem}
            >
              Logout
            </button>
          </>

        ) : (
          <>
            <button onClick={() => navigate("/AuthSwitch")} style={styles.sidebarItem}>
              Login
            </button>

            <button onClick={() => navigate("/AuthSwitch")} style={styles.sidebarItem}>
              Register
            </button>

            <button onClick={() => navigate("/global")} style={styles.sidebarItem}>
              Language & Currency
            </button>

         <button onClick={() => navigate("/CustomerSupport")} style={styles.sidebarItem}>
Help Center           
 </button>


            <button
              onClick={() => navigate("/AuthSwitch")}
              style={styles.sidebarItem}
            >
              Become a Host
            </button>
          </>
        )}
      </div>
    </div>
  </div>
)}



      {/* ================= MOBILE BOTTOM TABS ================= */}
{isMobile && !embedded && (
  <nav style={{
    ...styles.mobileTabs,
    transform: hideTabBar ? "translateY(100%)" : "translateY(0)",
    transition: "transform 0.3s ease",
  }}>
    

    <BottomTab
      icon={<Home size={22} />}
      label="Home"
      active
      onClick={() => handleTabClick("/")}
    />

    <BottomTab
      icon={<Compass size={22} />}
      label="Explore"
      onClick={() => handleTabClick("/explore")}
    />

    {isAuthenticated && (
      <BottomTab
        icon={<Calendar size={22} />}
        label="Reservations"
        onClick={() =>
          handleTabClick((userId) => `/ShortBookingsDashboard/${userId}`)
        }
      />
    )}

    {isAuthenticated && (
      <BottomTab
        icon={<MessageCircle size={22} />}
        label="Chat"
        onClick={() =>
          handleTabClick((userId) => "/imessagepreview/")
        }
      />
    )}

    <BottomTab
      label={user?.firstName || "Profile"}
      avatarUrl={isAuthenticated ? (user?.profilePicture || logoImg) : undefined}
      icon={<User size={22} />}
      onClick={() =>
        handleTabClick((userId) => `/profile/${userId}`)
      }
    />
  </nav>
)}

  </div>

{/*
{isMobile && <SmartFooter />}
*/}

    </div>
  );
};

export default VacationRentals;






/* ======================================================
   SMALL COMPONENTS
====================================================== */
const SearchItem = ({
  title,
  subtitle,
  onClick,
  active,
  dimmed,
}: {
  title: string;
  subtitle: string;
  onClick: () => void;
  active: boolean;
  dimmed: boolean;
}) => (
  <div
    onClick={onClick}
    style={{
      ...styles.searchItem,
      background: active ? "#fff" : dimmed ? GREY_BG : "transparent",
      boxShadow: active ? "0 6px 16px rgba(0,0,0,.18)" : "none",
      opacity: dimmed ? 0.6 : 1,
    }}
  >
    <div style={styles.searchTitle}>{title}</div>
    <div style={styles.searchSubtitle}>{subtitle}</div>
  </div>
);

const Divider = () => <div style={styles.verticalDivider} />;
const ListingSkeletonCard: React.FC = () => (
  <div style={styles.skeletonCard}>
    <div style={styles.skeletonLogoGrid}>
      {Array.from({ length: 9 }).map((_, i) => (
        <img key={i} src={logoImg} alt="" style={styles.skeletonLogoTile} />
      ))}
    </div>
    <div style={styles.skeletonShimmer} />
  </div>
);

const LoadingMoreDots: React.FC = () => (
  <div style={styles.loadingMoreWrap}>
    <div style={{ ...styles.loadingDot, background: "#d4af37", animationDelay: "0s" }} />
    <div style={{ ...styles.loadingDot, background: "#111", animationDelay: "0.15s" }} />
    <div style={{ ...styles.loadingDot, background: "#E50914", animationDelay: "0.3s" }} />
    <span style={styles.loadingMoreText}>Loading more</span>
  </div>
);


const TaxToggle = ({
  taxOn,
  setTaxOn,
}: {
  taxOn: boolean;
  setTaxOn: React.Dispatch<React.SetStateAction<boolean>>;
}) => (
  <div style={styles.taxCard} onClick={() => setTaxOn(!taxOn)}>
    <span>Display total before taxes</span>
    <div
      style={{
        ...styles.switch,
        background: taxOn ? GOLD_GRADIENT : "#ddd",
      }}
    >
      <div style={{ ...styles.knob, left: taxOn ? 18 : 2 }} />
    </div>
  </div>
);



const AnchorModal = ({ children, full, small, right, left }: any) => (
  <div
    style={{
      ...styles.anchorModal,
      width: full ? "100%" : small ? 320 : "100%",

      // ⬅️ LEFT-ALIGNED (Where)
      ...(left && {
        left: 0,
        transform: "none",
      }),

      // ➡️ RIGHT-ALIGNED (Who)
      ...(right && {
        right: 0,
        left: "auto",
        transform: "none",
      }),

      // 🎯 DEFAULT = CENTER (Dates)
      ...(!left && !right && {
        left: "50%",
        transform: "translateX(-50%)",
      }),
    }}
  >
    {children}
  </div>
);




const Modal = ({ children }: { children: React.ReactNode }) => (
  <div style={styles.modal}>{children}</div>
);



const BottomTab = ({
  icon,
  label,
  active,
  onClick,
  avatarUrl,
}: {
  icon?: React.ReactNode;
  label: string;
  active?: boolean;
  onClick: () => void;
  avatarUrl?: string;
}) => (
  <button
    onClick={onClick}
    style={{
      ...styles.tabItem,
      color: active ? "#000" : "#777",
    }}
  >
    {avatarUrl ? (
      <img
        src={avatarUrl}
        alt={label}
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).onerror = null;
          (e.currentTarget as HTMLImageElement).src = logoImg;
        }}
        style={{
          width: 22,
          height: 22,
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
    ) : (
      icon
    )}
    <span style={{ fontSize: 11, marginTop: 4 }}>{label}</span>
  </button>
);



/*===================================================
SHORTACCOMODATIONHOME CARDS
======================================================*/

interface ListingCardProps {
  stay: {
rateType?: "perNight" | "perHour" | "perNightPerPerson" | "perHourPerPerson" | "perWeek" | "perMonth" | "perYear";
   
    listingId: string;
    photos?: string[];
    rate?: number;
    address?: { city?: string; country?: string };
    rating?: number;
  };
  userId?: string;
  wishlist: { listingId: string }[];
  currencyProps: { rate: number; symbol: string; currency: string };

  // ✅ ADD
  checkIn: string | null;
  checkOut: string | null;
  guests: number;

}


const ListingCard: React.FC<ListingCardProps> = ({
  stay,
  userId,
  wishlist,
  currencyProps,
  checkIn,
  checkOut,
  guests,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [avgRating, setAvgRating] = useState<number | null>(null);
  //const { rate, symbol } = useContext(CurrencyContext);

// REPLACE WITH:
const { convertRaw, symbol, setCurrency } = useCurrency();

useEffect(() => {
  setCurrency("EUR");
}, []);

  const [totalReviews, setTotalReviews] = useState<number>(0);
const summary = useSelector(
  (state: RootState) => state.shortRatings.summaries[stay.listingId]
);

const finalPrice = useSelector(
  (state: RootState) =>
    state.shortstayServiceFees.finalPricesByListing?.[stay.listingId]
);

const filters = useSelector((state: RootState) => state.shortstays.filters);


//reviews
useEffect(() => {
  dispatch(fetchAllShortRatingSummaries());
}, [dispatch]);

useEffect(() => {
  if (summary) {
  const reviews = summary.totalReviews ?? 0;

  if (reviews >= 2) {
    setAvgRating(summary.avgRating ?? 0);
    setTotalReviews(reviews);
  } else {
      setAvgRating(0);
      setTotalReviews(0);
    }
  } else {
    setAvgRating(0);
    setTotalReviews(0);
  }
}, [summary]);



  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const isWishlisted = wishlist.some((item) => item.listingId === stay.listingId);

  const nextSlide = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % (stay.photos?.length || 1));
  };

  const prevSlide = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + (stay.photos?.length || 1)) % (stay.photos?.length || 1));
  };

  const toggleWishlist = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!userId) return alert("Please log in first");
  
    const type = "shortstays";
  
    if (isWishlisted) {
      dispatch(removeFromWishlist({ userId, listingId: stay.listingId, type }));
    } else {
      dispatch(addToWishlist({ userId, listingId: stay.listingId, type }));
    }
  };
  

  return (
<div
  style={styles.card}
onClick={() => {
  const q = new URLSearchParams();

  if (checkIn) q.set("checkIn", checkIn);
  if (checkOut) q.set("checkOut", checkOut);
  if (Number.isFinite(guests)) q.set("guests", guests.toString());

  navigate(
    `/roomdetails/${stay.listingId}${q.toString() ? `?${q.toString()}` : ""}`
  );
}}


>
      <div style={styles.imageWrapper}>
        {stay.photos && stay.photos.length > 1 && (
          <button style={styles.chevronLeft} onClick={prevSlide}>
            <ChevronLeft size={20} />
          </button>
        )}

        <img
          src={stay.photos?.[currentIndex] || 'https://via.placeholder.com/300'}
          alt="Stay"
          style={styles.image}
        />

        {stay.photos && stay.photos.length > 1 && (
          <button style={styles.chevronRight} onClick={nextSlide}>
            <ChevronRight size={20} />
          </button>
        )}
      </div>
      <button style={styles.heartButton} onClick={toggleWishlist}>
  {isWishlisted
    ? <FilledHeartIcon color="#f40d30" size={35} />
    : <OutlinedHeartIcon color="#fff" size={35} />}
</button>


{/* LOCATION DOME */}
<div style={styles.locationDome}>
  <MapPin size={14} style={{ marginRight: 6 }} />
  {[stay.address?.city, stay.address?.country].filter(Boolean).join(", ")}
</div>


{/* RATING DOME 

{totalReviews >= 2 ? (
  <div style={styles.ratingDome}>
    <Star size={14} /> {avgRating?.toFixed(1)} ({totalReviews})
  </div>
) : (
  <div style={styles.noRatingDome}>No reviews</div>
)}
*/}


{totalReviews >= 2 && (
  <div style={styles.ratingDome}>
    <Star size={14} /> {avgRating?.toFixed(1)} ({totalReviews})
  </div>
)}


{/* FINAL PRICE DOME */}
{finalPrice && (
  <div style={styles.finalPriceDome}>
    <span style={{ opacity: 0.85, fontWeight: 600, marginRight: 6 }}>
      You Pay:
    </span>
    {symbol}
    {Number(convertRaw(finalPrice.totalCharged ?? 0, "EUR")).toLocaleString()}
  </div>
)}


{/* PRICE DOME */}
<div style={styles.priceDome}>
  {stay.rate ? (
    <>
    {/*
      {symbol}
      {Number(stay.rate * rate).toLocaleString()}
    */}

      {symbol}
{Number(convertRaw(stay.rate ?? 0, "EUR")).toLocaleString()}
      {"/"}
 {stay.rateType === "perNight"
        ? "night"
        : stay.rateType === "perNightPerPerson"
        ? "person · night"
        : stay.rateType === "perHour"
        ? "hour"
        : stay.rateType === "perHourPerPerson"
        ? "person · hour"
        : stay.rateType === "perWeek"
        ? "week"
        : stay.rateType === "perMonth"
        ? "month"
        : stay.rateType === "perYear"
        ? "year"
        : "night"}
    </>
  ) : (
    "Price N/A"
  )}
</div>



    </div>
  );
};







/* ======================================================
   TOP EARLY-HOST CARD (small square, Airbnb-style)
====================================================== */
interface TopHostCardProps {
  stay: {
    listingId: string;
    photos?: string[];
    address?: { city?: string; country?: string };
    rate?: number;
    rateType?: "perNight" | "perHour" | "perNightPerPerson" | "perHourPerPerson" | "perWeek" | "perMonth" | "perYear";
  };
  checkIn: string | null;
  checkOut: string | null;
  guests: number;
}

const rateTypeLabel = (rateType?: string) => {
  switch (rateType) {
    case "perNight": return "/night";
    case "perNightPerPerson": return "/person·night";
    case "perHour": return "/hour";
    case "perHourPerPerson": return "/person·hour";
    case "perWeek": return "/week";
    case "perMonth": return "/month";
    case "perYear": return "/year";
    default: return "/night";
  }
};


const TopHostCard: React.FC<TopHostCardProps> = ({ stay, checkIn, checkOut, guests }) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const { convertRaw, symbol } = useCurrency();
  const [isMobileCard, setIsMobileCard] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobileCard(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const summary = useSelector(
    (state: RootState) => state.shortRatings.summaries[stay.listingId]
  );
  const totalReviews = summary?.totalReviews ?? 0;
const avgRating = summary?.avgRating ?? 0;
const hasRating = totalReviews >= 2;

  const photoCount = stay.photos?.length || 0;

  const nextSlide = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % (photoCount || 1));
  };

  const prevSlide = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + (photoCount || 1)) % (photoCount || 1));
  };

  return (
    <div
      style={{
        ...styles.topHostCard,
        ...(isMobileCard
          ? {}
          : { width: "100%", minWidth: 0, maxWidth: "none" }),
      }}
      onClick={() => {
        const q = new URLSearchParams();
        if (checkIn) q.set("checkIn", checkIn);
        if (checkOut) q.set("checkOut", checkOut);
        if (Number.isFinite(guests)) q.set("guests", guests.toString());

        navigate(
          `/roomdetails/${stay.listingId}${q.toString() ? `?${q.toString()}` : ""}`
        );
      }}
    >
      <div style={styles.topHostImageWrapper}>
        {photoCount > 1 && (
          <button style={styles.topHostChevronLeft} onClick={prevSlide}>
            <ChevronLeft size={14} />
          </button>
        )}

        <img
          src={stay.photos?.[currentIndex] || "https://via.placeholder.com/300"}
          alt="Stay"
          style={styles.topHostImage}
        />

        {photoCount > 1 && (
          <button style={styles.topHostChevronRight} onClick={nextSlide}>
            <ChevronRight size={14} />
          </button>
        )}

        {/* RATING — bottom left, gold dome like the big card */}
 {/* RATING — bottom left, gold dome like the big card */}
        {hasRating && (
          <div style={styles.topHostRatingDome}>
            <Star size={11} /> {avgRating.toFixed(1)}
          </div>
        )}

        {/* RATE — bottom right, small price/rateType chip */}
        {stay.rate ? (
          <div style={styles.topHostRateDome}>
            {symbol}{Number(convertRaw(stay.rate ?? 0, "EUR")).toLocaleString()}
            <span style={{ opacity: 0.85, fontWeight: 600 }}>{rateTypeLabel(stay.rateType)}</span>
          </div>
        ) : null}
      </div>

      <div style={styles.topHostLocation}>
        {[stay.address?.city, stay.address?.country].filter(Boolean).join(", ")}
      </div>
    </div>
  );
};



/* ======================================================
   STYLES
====================================================== */
const styles: Record<string, React.CSSProperties> = {
 wrapper: { background: "#fff", position: "relative", zIndex: 30 },
pageContent: {
  position: "relative",
},
pageWatermark: {
  position: "absolute",
  inset: 0,
  backgroundImage: `url(${logoImg})`,
  backgroundRepeat: "repeat",
  backgroundSize: "110px 110px",
  opacity: 0.06,
  pointerEvents: "none",
  zIndex: 0,
},
searchWrapper: {
  display: "flex",
  padding: "10px 16px",
  position: "relative",
  background: "#fff",
},


  centerWrap: { flex: 1, display: "flex", justifyContent: "center" },

searchPill: {
  display: "flex",
  alignItems: "center",
  borderRadius: 999,
  border: "1px solid #e5e5e5",
  background: "#f7f7f7",
  position: "relative",
  maxWidth: "100%",      // ← constrain to parent
  boxSizing: "border-box",
},

  searchItem: {
    padding: "14px 18px",
    minWidth: 150,
    cursor: "pointer",
    borderRadius: 999,
    transition: "all .2s",
  },

  searchTitle: { fontSize: 12, fontWeight: 700 },
  searchSubtitle: { fontSize: 13, color: "#777" },

  verticalDivider: { width: 1, height: 32, background: "#e5e5e5" },

  searchBtn: {
    background: GOLD_GRADIENT,
    border: "none",
    borderRadius: "50%",
    width: 44,
    height: 44,
    margin: 8,
    display: "grid",
    placeItems: "center",
  },


 
  /*anchorModal: { position: "absolute", top: "calc(100% + 8px)", left: 0, background: "#fff", borderRadius: 20, boxShadow: "0 20px 40px rgba(0,0,0,.25)", padding: 24, zIndex: 1000, },*/

 

  
anchorModal: {
  position: "absolute",
  top: "calc(100% + 12px)",
  background: "#fff",
  borderRadius: 20,
  boxShadow: "0 20px 40px rgba(0,0,0,.25)",
  padding: 24,
  zIndex: 5000,
  maxWidth: "calc(100vw - 48px)",  // ← never wider than viewport
  boxSizing: "border-box",         // ← padding included in width
},






 

  mobilePill: {
    display: "flex",
    alignItems: "center",
    borderRadius: 999,
    border: "1px solid #e5e5e5",
    background: "#fff",
    width: "100%",
    maxWidth: 420,
  },

  mobileBlock: { flex: 1, padding: "14px 16px" },

  mobileAnchor: {
    margin: "12px auto",
    maxWidth: 420,
    background: "#fff",
    borderRadius: 20,
    padding: 24,
    boxShadow: "0 14px 36px rgba(0,0,0,.18)",
  },

profileMenuBtn: {
  display: "flex",
  alignItems: "center",
  gap: 8,

  height: 48,              // ✅ EXACT same visual height as Who
  padding: "0 14px",       // ✅ horizontal only
  minWidth: 80,            // keeps oval, not circle

  borderRadius: 999,
  border: "1px solid #ddd",
  background: "#fff",

  boxShadow: "0 2px 6px rgba(0,0,0,.12)",
  cursor: "pointer",

  transition: "box-shadow .2s, transform .15s",
},



  separator: {
    height: 1, 
    background: "#eee", 
    width: "100%",
      zIndex: 1,
   },

categoriesRow: {
  display: "flex",
  alignItems: "center",
  padding: "8px 24px",
  gap: 16,
  width: "100%",
  boxSizing: "border-box",
  overflow: "hidden", 
},


  categories: { display: "flex", gap: 24, flex: 1 },

categoryItem: {
  fontSize: 12,
  fontWeight: 600,
  cursor: "pointer",
  background: "transparent",
  border: "none",
  padding: "6px 4px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  whiteSpace: "nowrap",
},
categoriesWrap: {
  display: "flex",
  alignItems: "center",
  gap: 12,
  flex: 1,              // 🔥 THIS enables scroll space
  minWidth: 0,          // 🔥 critical for overflow to work
},
categoriesScroll: {
  display: "flex",
  gap: 24,
  overflowX: "auto",
  overflowY: "hidden",
  scrollBehavior: "smooth",

  flex: 1,
  minWidth: 0,

  paddingBottom: 4,
  scrollbarWidth: "none",
},


  navBtn: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    border: "1px solid #ddd",
    background: "#fff",
    display: "grid",
    placeItems: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,.15)",
  },

rightControls: {
  display: "flex",
  gap: 12,
  flexShrink: 0,   // 🔥 CRITICAL
},

  filtersBtn: {
    padding: "8px 14px",
    borderRadius: 14,
    border: "1px solid #ddd",
    background: "#fff",
    fontWeight: 600,
  },

  taxCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    width: "100%",
    boxSizing: "border-box",
    padding: "14px 18px",
    borderRadius: 16,
    border: "1px solid #f0f0f0",
    background: "#fff",
    boxShadow: "0 3px 0px #e2e2e2, 0 4px 10px rgba(0,0,0,0.08)",
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
    transition: "box-shadow .15s, transform .15s",
  },

  switch: { width: 40, height: 22, borderRadius: 999, position: "relative" },
  knob: {
    position: "absolute",
    top: 2,
    width: 18,
    height: 18,
    borderRadius: "50%",
    background: "#fff",
    transition: "left .2s",
  },

  modal: {
    margin: "12px auto",
    maxWidth: 760,
    padding: 24,
    background: "#fff",
    borderRadius: 20,
    boxShadow: "0 14px 36px rgba(0,0,0,0.18)",
  },

  sideMenu: {
    position: "fixed",
    inset: 0,
    background: "#fff",
    padding: 24,
    zIndex: 3000,
  },

  closeBtn: {
    borderRadius: "50%",
    width: 36,
    height: 36,
    border: "1px solid #ddd",
    background: "#fff",
  },
  mobileTabs: {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,

  height: 64,
  background: "#fff",

  borderTop: "1px solid #e5e5e5",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",

  zIndex: 1000,
},

tabItem: {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",

  background: "none",
  border: "none",
  padding: 0,

  cursor: "pointer",
},
mobileSheetBackdrop: {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,.4)",
  zIndex: 999,
},

mobileSheet: {
  position: "absolute",
  bottom: 0,
  boxShadow: "0 -10px 30px rgba(0,0,0,.25)",
  left: 0,
  right: 0,
  background: "#fff",
  borderTopLeftRadius: 24,
  borderTopRightRadius: 24,
  maxHeight: "85vh",
  overflowY: "auto",
  paddingBottom: 88,
},

mobileCard: {
  background: "#fff",
  borderRadius: 16,
  margin: 12,
  boxShadow: "0 4px 12px rgba(0,0,0,.12)",
},

cardPreview: {
  padding: 18,
  display: "flex",
  justifyContent: "space-between",
  cursor: "pointer",
},

guestRow: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 16,
},

counterRow: {
  display: "flex",
  gap: 10,
  alignItems: "center",
},

mobileSearchBtn: {
  width: "100%",
  padding: 14,
  borderRadius: 999,
  background: "#E51E24",
  color: "#fff",
  fontWeight: 700,
  border: "none",
},
weekRow: {
  display: "grid",
  gridTemplateColumns: "repeat(7,1fr)",
  textAlign: "center",
  fontSize: 12,
  color: "#666",
  marginBottom: 6,
},


weekLabel: {
  fontWeight: 600,
},

daysGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(7,1fr)",
  gap: 2, // 🔥 RN density
},

dayBtn: {
  position: "relative",
  zIndex: 1,
  width: 36,
  height: 36,
  borderRadius: "50%", // 🔥 CIRCLE
  border: "none",
  fontWeight: 600,
  background: "transparent",
},

rangeBg: {
  position: "absolute",
  top: "50%",
  left: -6,
  right: -6,
  height: 36,
  transform: "translateY(-50%)",
  background: "rgba(212,175,55,0.25)", // gold wash
  zIndex: 0,
},
/* ================= MOBILE SHEET HEADER ================= */
sheetHeader: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px 20px",
  borderBottom: "1px solid #eee",
  fontSize: 16,
},

/* ================= WHEN TOGGLE ================= */
whenToggle: {
  display: "flex",
  gap: 8,
  marginBottom: 16,
  background: "#f5f5f5",
  borderRadius: 999,
  padding: 4,
},

whenToggleBtn: {
  flex: 1,
  padding: "10px 0",
  borderRadius: 999,
  border: "none",
  fontWeight: 700,
  fontSize: 13,
  cursor: "pointer",
  background: "transparent",
},

/* ================= MONTH GRID ================= */
monthGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(3,1fr)",
  gap: 12,
},

monthBtn: {
  padding: "16px 0",
  borderRadius: 14,
  border: "1px solid #e5e5e5",
  fontWeight: 700,
  background: "#fff",
  cursor: "pointer",
},

/* ================= FLEX BUTTONS ================= */
flexBtn: {
  flex: 1,
  padding: "14px 0",
  borderRadius: 999,
  border: "1px solid #e5e5e5",
  fontWeight: 700,
  cursor: "pointer",
  background: "#fff",
},

guestBtn: {
  width: 32,
  height: 32,
  borderRadius: "50%",
  border: "1px solid #ddd",
  background: "#fff",
  display: "grid",
  placeItems: "center",
  cursor: "pointer",
},
searchAnchor: {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  width: "100%",
  overflow: "visible",   // modals need to escape
  minWidth: 0,           // ← prevents flex child from overflowing parent
},

//listingcard

  listingsGrid: {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
  gap: 20,
  padding: `0 ${H_PADDING}px`,
  boxSizing: 'border-box',
  width: '100%',
  marginTop: 20,
},

skeletonCard: {
  position: "relative",
  borderRadius: 12,
  overflow: "hidden",
  aspectRatio: "1/1",
  background: "#f2f2f2",
},
skeletonShimmer: {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(90deg, rgba(242,242,242,0) 0%, rgba(212,175,55,0.35) 50%, rgba(242,242,242,0) 100%)",
  backgroundSize: "250% 100%",
  animation: "shimmer 1.6s ease infinite",
  mixBlendMode: "multiply",
},
skeletonLogoGrid: {
  position: "absolute",
  inset: 0,
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gridTemplateRows: "repeat(3, 1fr)",
  placeItems: "center",
  padding: 12,
  gap: 4,
},
skeletonLogoTile: {
  width: "40%",
  height: "auto",
  objectFit: "contain",
  opacity: 0.18,
  filter: "grayscale(1)",
},
loadingMoreWrap: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  padding: "80px 0",
},
loadingDot: {
  width: 12,
  height: 12,
  borderRadius: "50%",
  animation: "dotBounce 1s ease-in-out infinite",
},
loadingMoreText: {
  marginLeft: 8,
  fontWeight: 700,
  fontSize: 13,
  color: "#777",
},
    card: {
      position: 'relative',
      borderRadius: 12,
      overflow: 'hidden',
      backgroundColor: '#fff',
      cursor: 'pointer',
    },
    imageWrapper: {
      position: 'relative',
      width: '100%',
      aspectRatio: '1/1',
    },
   image: {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
},
    chevronLeft: {
      position: 'absolute',
      top: '50%',
      left: 10,
      transform: 'translateY(-50%)',
      backgroundColor: 'rgba(0,0,0,0.4)',
      border: 'none',
      borderRadius: '50%',
      padding: 8,
      cursor: 'pointer',
      zIndex: 2,
    },
    chevronRight: {
      position: 'absolute',
      top: '50%',
      right: 10,
      transform: 'translateY(-50%)',
      backgroundColor: 'rgba(0,0,0,0.4)',
      border: 'none',
      borderRadius: '50%',
      padding: 8,
      cursor: 'pointer',
      zIndex: 2,
    },
    heartButton: {
      position: 'absolute',
      top: 10,
      right: 10,
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      zIndex: 3,
    },
    overlay: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent)',
      color: '#fff',
      padding: '10px 12px',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
    price: {
      fontWeight: 'bold',
    },
    location: {
      flex: 1,
      fontSize: 12,
      textAlign: 'center',
    },
    rating: {
      display: 'flex',
      alignItems: 'center',
      gap: 4,
    },

locationDome: {
  position: 'absolute',
  top: 0,
  left: 0,
  padding: '10px 16px',
  borderTopLeftRadius: 12,
  borderBottomRightRadius: 40,
  background: 'linear-gradient(135deg, rgba(0,0,0,0.85), #C8202E)',
  color: '#fff',
  fontWeight: 700,
  fontSize: 13,
  zIndex: 5,
},

ratingDome: {
  position: 'absolute',
  top: 46,
  left: 0,
  padding: '6px 14px',
  borderTopRightRadius: 40,
  borderBottomRightRadius: 40,
  background: 'linear-gradient(135deg, #ffefba, #d4af37, #C8202E)',
  color: '#fff',
  fontWeight: 700,
  fontSize: 13,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  zIndex: 5,
},

noRatingDome: {
  position: 'absolute',
  top: 46,
  left: 0,
  padding: '6px 14px',
  borderTopRightRadius: 40,
  borderBottomRightRadius: 40,
  background: 'rgba(0,0,0,0.7)',
  color: '#ddd',
  fontSize: 12,
  zIndex: 5,
},

priceDome: {
  position: 'absolute',
  bottom: 0,
  left: 0,
  padding: '12px 20px',
  borderTopRightRadius: 45,
  borderBottomLeftRadius: 12,
  background: 'linear-gradient(135deg, #737373ff, #000000ff, #C8202E)',
  color: '#fff',
  fontWeight: 900,
  fontSize: 16,
  zIndex: 5,
},

  finalPriceDome: {
  position: 'absolute',
  top: 78,
  left: 0,
  padding: '6px 14px',
  borderTopRightRadius: 40,
  borderBottomRightRadius: 40,
  background: 'linear-gradient(135deg, rgba(0,0,0,0.75), rgba(0,0,0,0.9))',
  color: '#fff',
  fontWeight: 900,
  fontSize: 14,
  zIndex: 5,
  backdropFilter: 'blur(2px)',   // ✨ premium glass effect
},
sidebarOverlay: {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "flex-end",
  zIndex: 6000,
},

sidebar: {
  width: "100%",
  height: "100%",
  background: "linear-gradient(135deg, gold, white, black)",
  boxShadow: "0 0 20px rgba(0,0,0,0.4)",
  padding: 24,
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
},

sidebarContent: {
  marginTop: 70,
  display: "flex",
  flexDirection: "column",
  gap: 14,
},

sidebarItem: {
  padding: "12px 16px",
  borderRadius: 12,
  border: "none",
  background: "rgba(255,255,255,0.25)",
  color: "#000",
  fontWeight: 700,
  textAlign: "left",
  cursor: "pointer",
  backdropFilter: "blur(3px)",
  transition: "transform .15s ease, box-shadow .15s ease",
},
  
notificationBtn: {
  position: "relative", 
  width: 48,
  height: 48,
  borderRadius: "50%",
  border: "1px solid #ddd",
  background: "#fff",
  display: "grid",
  placeItems: "center",
  boxShadow: "0 2px 6px rgba(0,0,0,.12)",
  cursor: "pointer",
},
notificationBadge: {
  position: "absolute",
  top: -4,         
  right: -4,       
  background: "#e50914",
  color: "#fff",
  fontSize: 10,
  fontWeight: 900,
  width: 18,
  height: 18,
  borderRadius: "50%",  
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 4px 10px rgba(0,0,0,.35)",
},


notificationDot: {
  position: "absolute",
  top: 10,
  right: 12,
  width: 8,
  height: 8,
  borderRadius: "50%",
  background: "#E50914", // Netflix red
},
filterRow:{
 display:"flex",
 justifyContent:"space-between",
 alignItems:"center",
 padding:"10px 0",
 borderBottom:"1px solid #eee",
 cursor:"pointer"
},

filterInput:{
 width:"100%",
 padding:"10px",
 borderRadius:10,
 border:"1px solid #ddd"
},

applyBtn:{
 flex:1,
 background:"#E50914",
 color:"#fff",
 border:"none",
 padding:"12px",
 borderRadius:10,
 fontWeight:700
},

clearBtn:{
 flex:1,
 border:"1px solid #ddd",
 background:"#fff",
 padding:"12px",
 borderRadius:10,
 fontWeight:600
},  


topHostsSection: {
  padding: `0 ${H_PADDING}px`,
  boxSizing: "border-box",
  width: "100%",
},

topHostsHeaderGradient: {
  fontSize: 16,
  fontWeight: 800,
  marginBottom: 14,
  display: "inline-block",
  backgroundImage: "linear-gradient(90deg,#0a0a0a,#bf9b30,#d46b10,#e84020,#bf9b30,#0a0a0a)",
  backgroundSize: "300% 100%",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  animation: "aeSpin 3s linear infinite",
},

// Mobile: horizontally scrollable strip, ~3 cards visible at once
topHostsScroll: {
  display: "flex",
  gap: 14,
  overflowX: "auto",
  overflowY: "hidden",
  scrollSnapType: "x mandatory",
  paddingBottom: 8,
  scrollbarWidth: "none",
  WebkitOverflowScrolling: "touch",
},

// Desktop: fixed 6-column grid, no scroll
topHostsGridDesktop: {
  display: "grid",
  gridTemplateColumns: "repeat(6, 1fr)",
  gap: 16,
},

topHostCard: {
  position: "relative",
  flex: "0 0 auto",
  // mobile-only sizing (ignored on desktop grid since grid controls width via 1fr)
  width: "calc((100vw - 20px*2 - 14px*2) / 3.3)",
  minWidth: 96,
  maxWidth: 160,
  cursor: "pointer",
  scrollSnapAlign: "start",
},

topHostImageWrapper: {
  position: "relative",
  width: "100%",
  aspectRatio: "1/1",
  borderRadius: 12,
  overflow: "hidden",
  backgroundColor: "#eee",
},

topHostImage: {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
},

topHostChevronLeft: {
  position: "absolute",
  top: "50%",
  left: 4,
  transform: "translateY(-50%)",
  backgroundColor: "rgba(0,0,0,0.4)",
  border: "none",
  borderRadius: "50%",
  padding: 3,
  cursor: "pointer",
  color: "#fff",
  display: "flex",
  zIndex: 2,
},

topHostChevronRight: {
  position: "absolute",
  top: "50%",
  right: 4,
  transform: "translateY(-50%)",
  backgroundColor: "rgba(0,0,0,0.4)",
  border: "none",
  borderRadius: "50%",
  padding: 3,
  cursor: "pointer",
  color: "#fff",
  display: "flex",
  zIndex: 2,
},

topHostRatingDome: {
  position: "absolute",
  bottom: 6,
  left: 6,
  padding: "4px 8px",
  borderRadius: 999,
  background: "linear-gradient(135deg, #ffefba, #d4af37, #b8860b)",
  color: "#fff",
  fontWeight: 700,
  fontSize: 11,
  display: "flex",
  alignItems: "center",
  gap: 3,
  zIndex: 3,
},


topHostRateDome: {
  position: "absolute",
  bottom: 6,
  right: 6,
  padding: "4px 8px",
  borderRadius: 999,
  background: "linear-gradient(135deg, #737373ff, #000000ff, #a67c00)",
  color: "#fff",
  fontWeight: 800,
  fontSize: 10,
  display: "flex",
  alignItems: "center",
  gap: 3,
  zIndex: 3,
  whiteSpace: "nowrap",
},

topHostLocation: {
  marginTop: 6,
  fontSize: 12,
  fontWeight: 600,
  color: "#333",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
},

pioneerCtaText: {
  fontSize: 17,
  fontWeight: 800,
  display: "inline-block",
  backgroundImage: "linear-gradient(90deg,#0a0a0a,#bf9b30,#d46b10,#e84020,#bf9b30,#0a0a0a)",
  backgroundSize: "300% 100%",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  animation: "aeSpin 3s linear infinite",
  maxWidth: 280,
  marginLeft: "auto",
  marginRight: "auto",
  lineHeight: 1.4,
},
pioneerCollapseBtn: {
  position: "absolute",
  top: 0,
  right: 20,
  width: 28,
  height: 28,
  borderRadius: "50%",
  border: "1px solid #ddd",
  background: "#fff",
  display: "grid",
  placeItems: "center",
  cursor: "pointer",
  boxShadow: "0 2px 6px rgba(0,0,0,.12)",
  zIndex: 2,
},

pioneerReopenBar: {
  display: "flex",
  justifyContent: "center",
  padding: "6px 0",
  marginTop: 8,
},

pioneerReopenBtn: {
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)",
  marginTop: 4,
  width: 28,
  height: 28,
  borderRadius: "50%",
  border: "1px solid #ddd",
  background: "#fff",
  display: "grid",
  placeItems: "center",
  cursor: "pointer",
  boxShadow: "0 2px 6px rgba(0,0,0,.12)",
  opacity: 0.7,
  zIndex: 2,
},
};